// @flow
import React, { Component } from "react";
import Slider from "react-rangeslider";
import "react-rangeslider/lib/index.css";
import "react-responsive-modal/styles.css";
import "./custom.css";

import Modal, {
  ModalBody,
  ModalTransition,
  ModalHeader,
  ModalTitle,
  ModalFooter,
} from "@atlaskit/modal-dialog";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { AUDIO_CHANNEL_MODE, displayConsole, getPublicIp } from "../helper";
import { connect } from "../../base/redux";
import { i18next, translate } from "../../base/i18n";
import { sendData } from "../websocket";

import cross from "./img/cross.png";
import radioActive from "./img/radioActive.png";
import radioInactive from "./img/radioInactive.png";
import red from "./img/red.png";
import green from "./img/green.png";
import calc from "./img/calc.gif";

import axios from "axios";
import { Constant, CURRENT_ROOM_LOCATION, CURRENT_ROOM_NAME, USER_NAME_LEN } from "../constant";
import {
  FEATURE_CUSTOM_REDUX,
  FEATURE_CUSTOM_REDUX_V2,
  FEATURE_CUSTOM_REDUX_V3,
} from "../../customise/constant";

import {
  setBufferValue,
  setHostTabData,
  setHostTabReload,
  showApiLoader,
  setGhostVoiceSync,
  connectAudioGhost,
  hideApiLoader,
  setHybridSession,
  clickAutoMakeHost,
  setAutoMakeHost,
  setHostRefresh,
  setHostRefreshTimer,
  setPrevPanning,
  setHostInitWait,
  setRoomorIpAddress,
} from "../../customise/redux/tool-webjam/actions";
import {
  getLocalParticipant,
  getRemoteParticipants,  // CUSTOM
  isLocalParticipantModerator,
  participantUpdated,
} from "../../base/participants";
import { updateSettings } from "../../base/settings";
import Toast from "react-simple-toasts";
import refresh from "./img/refresh.png";

import RTChart from "react-rt-chart";
import { Chart } from "react-google-charts";
import {
  showNotification,
  showErrorNotification,
  hideNotification,
  NOTIFICATION_TIMEOUT_TYPE,
} from "../../notifications";
import { socketEmit, socketOn } from "../../../../socket";
// import { filterRemoteParticipant, PANNING_VAR, _ValidateIPaddress } from '../../customise/Utils';
import {
  dispatch,
  getBaseConfig,
  isMobileBrowserC,
  PANNING_VAR,
  _ValidateIPaddress,
  isIpad,
  getStore,
} from "../../customise/Utils";
import { isNumeric } from "jquery";
import { messages } from "../../customise/welcome-dashboard/messages";
import { Translate } from "../../webjam/language";

import Config from "../../customise/config";
const { socket_endpoint } = Config;
import { apiVersion } from "../../customise/welcome-dashboard/Utils";
import { setAudioChannel } from "../../customise/redux/tool-webjam/actions";
import {
  setAudioChannelAdditionalSetting,
  setAudioStereo,
  setIsBufferChange,
  setOutAutoManage,
} from "../../customise/redux/tool-webjam-v2/actions";
import Button from "@atlaskit/button";
import { sendAnalytics } from "../../analytics";
import Radio from "./icon-components/Radio";
import {
  getBufferDelayApi,
  getHybridSessionStatus,
  kickoutHybridUser,
  profileNameUpdateApi,
  thirdPartyMakeHostApi,
} from "../../customise/welcome-dashboard/Request.d";
import { JitsiRecordingConstants } from "../../base/lib-jitsi-meet";
import { getActiveSession } from "../../recording";
import {
  setAutoMakeHostTrigger,
  setConfirmationModalProps,
  setIsEventRequestingLoader,
  setLocalAutoConnect,
  setLocalBufferValue,
} from "../../customise/redux/tool-webjam-v3/actions";
import { SaveLog } from "../../customise/Utils";
import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import { MixerTooltip } from "./mixer";
import { getDisplayName } from '../../base/settings/index';
import { ct, dynamicMessageLocale } from "../../customise/constant-Utils";
import { setVolume } from "../../filmstrip/actions.web";
import toast from "react-simple-toasts";

let AUDIO_CHANNEL_ZERO = "Mono",
  AUDIO_CHANNEL_ONE = "Mono-in/Stereo-out",
  AUDIO_CHANNEL_TWO = "Stereo",
  AUDIO_QUALITY_ZERO = "Low",
  AUDIO_QUALITY_ONE = "Normal",
  AUDIO_QUALITY_TWO = "High",
  qualityArray = [{ value: AUDIO_QUALITY_ZERO, locale: "rta-trmc.mixer.low" }, { value: AUDIO_QUALITY_ONE, locale: "rta-trmc.mixer.normal" }, { value: AUDIO_QUALITY_TWO, locale: "rta-trmc.mixer.high" }],
  channelsArray = [{ value: AUDIO_CHANNEL_ZERO, locale: "rta-trmc.mixer.mono" }, { value: AUDIO_CHANNEL_ONE, locale: "rta-trmc.mixer.monoInOut" }, { value: AUDIO_CHANNEL_TWO, locale: "rta-trmc.mixer.stereo" }],
  instrumentArray = [
    "None",
    "Drum Set",
    "Djembe",
    "Electric Guitar",
    "Acoustic Guitar",
    "Bass Guitar",
    "Keyboard",
    "Synthesizer",
    "Grand Piano",
    "Accordion",
    "Vocal",
    "Microphone",
    "Harmonica",
    "Trumpet",
    "Trombone",
    "French Horn",
    "Tuba",
    "Saxophone",
    "Clarinet",
    "Flute",
    "Violin",
    "Cello",
    "Double Bass",
    "Recorder",
    "Streamer",
    "Listener",
    "Guitar+Vocal",
    "Keyboard+Vocal",
    "Bodhran",
    "Bassoon",
    "Oboe",
    "Harp",
    "Viola",
    "Congas",
    "Bongo",
    "Vocal Bass",
    "Vocal Tenor",
    "Vocal Alto",
    "Vocal Soprano",
    "Banjo",
    "Mandolin",
  ],
  deviceArray = ["Jack"],
  timeoutLeftFader,
  timeoutRightFader,
  timeoutProfileName,
  selectedUniqueId,
  chartdataCount = 0;

let hybridClickedYes = true;

class Settings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //firstname: 'RTA User',
      //firstname: localStorage.getItem('firstname') != null && localStorage.getItem('firstname') != undefined ? localStorage.getItem('firstname') : 'RTA User',
      // firstname: localStorage.getItem('firstname') != null && localStorage.getItem('firstname') != undefined ? localStorage.getItem('firstname') : "",
      firstname:
        localStorage.getItem("firstname") != null &&
          localStorage.getItem("firstname") != undefined
          ? localStorage.getItem("firstname")
          : getBaseConfig("userName"),
      instrumentName: "",
      device: "",
      audioChannel: "",
      audioQuality: "",
      sliderLeftValue: 0,
      sliderRightValue: 0,
      isJitBuf: false,
      isSmallNetworkEnable: false,
      /*currentSetting: '0',
      defaultSetting: '0',
      prefSetting: '0',
      safeSetting: '0'*/
      dropCount: 0,
      sliderPanValue: 0,
      sliderReverbValue: 0,
      leftReverb: false,
      rightReverb: true,
      isAddressIP: false,
      ipNewroom: "",
      showNewRoomModal: false,
      pingTimeChart: 0,
      chartdata: [
        ["x", "overall delay", "ping time", "processing delay"],
        [0, 0, 0, 0],
      ],
      showInfo: false,
      info: ct("rta-trmc.mixer.infoMsg1"),
      //selectedUniqueId: ''
      tabSelected: sessionStorage.getItem("tabSelected")
        ? parseInt(sessionStorage.getItem("tabSelected"))
        : 0,
      isHybridSessionActive: false,
      isAutoManageHostClicked: true,
      makeHostUniqueId: "",
      initialWait: true,
      localAudioChange: false,
      prevVolState: {
        mono: false,
        mode: "",
      },
      showHostRefresh: false,
      automaticMakeHost: true,
      orientationView: window?.screen?.orientation?.type || "portrait-primary"
    };
  }

  getOrientation = (orientation) => {
    if (this.state.orientationView !== orientation) {
      this.setState({ orientationView: orientation });
    }
  }

  componentDidMount() {
    const {
      usersData,
      latencyData,
      hostTabData,
      hostReload,
      isVoiceSync,
      isConnectedAudioGhost,
      isHybridSession,
      clickedAutoMakeHost,
      roomorIpAddress,
      deviceUserName,
      _isLiveStreamRunning,
      _isRecordingRunning,
      outAutoManage,
    } = this.props;

    if (sessionStorage.getItem("tabSelected")) {
      sessionStorage.removeItem("tabSelected");
    }
    let this_ = this;
    setTimeout(() => {
      let hasSelectedTb = sessionStorage.getItem("mixer_tab_" + CURRENT_ROOM_NAME);
      if (hasSelectedTb) {
        hasSelectedTb = parseInt(hasSelectedTb) || 0;
        this.setState({
          tabSelected: hasSelectedTb
        })
        sessionStorage.removeItem("mixer_tab_" + CURRENT_ROOM_NAME)
      }
    }, 100)

    this.publicIpcheck();

    this.setState({
      //firstname: usersData && usersData.myName ? usersData.myName : 'RTA User',
      // firstname: usersData && usersData.myName ? usersData.myName : "",
      // firstname: usersData && usersData.myName ? usersData.myName : getBaseConfig("userName"),
      profileName: "",
      instrumentName:
        usersData && usersData.instrument
          ? instrumentArray[usersData.instrument]
          : 0,
      device: "Jack",
      sliderLeftValue: usersData.sliderLeft,
      sliderRightValue: usersData.sliderRight,
      audioChannel:
        usersData.audioChannel == 0
          ? AUDIO_CHANNEL_ZERO
          : usersData.audioChannel == 1
            ? AUDIO_CHANNEL_ONE
            : AUDIO_CHANNEL_TWO,
      audioQuality:
        usersData.audioQuality == 0
          ? AUDIO_QUALITY_ZERO
          : usersData.audioQuality == 1
            ? AUDIO_QUALITY_ONE
            : AUDIO_QUALITY_TWO,
      isJitBuf: usersData.isJitBuf,
      isSmallNetworkEnable: usersData.isSmallNetworkEnable,
      currentSettingValue: usersData.currentSettingValue,
      prefSettingValue: usersData.prefSettingValue,
      defaultSettingValue: usersData.defaultSettingValue,
      safeSettingValue: usersData.defaultSetting,
      firstBufferDelay: false,
      secondBufferDelay: false,
      thirdBufferDelay: false,
      showJitterBuffer: false,
      showdrop: false,
      pingTimeChart: 0,
      dropCount: 0,
      sliderPanValue: usersData.panLevel,
      sliderReverbValue: usersData.reverbLevel,
      leftReverb: usersData.leftReverb,
      rightReverb: !usersData.leftReverb,
      //isAddressIP: false
      isAddressIP: _ValidateIPaddress(roomorIpAddress),
      // ipNewroom: '',
      // showNewRoomModal: false,
      //selectedUniqueId: ''
      isAutoManageHostClicked: clickedAutoMakeHost,
      localAudioChange: false,
      showJitterIP: false,
    });

    let userNameSet = "";

    if (deviceUserName) {
      userNameSet = deviceUserName;
    } else if (usersData?.myName) {
      userNameSet = usersData.myName;
    }

    if (userNameSet.indexOf("___") != -1) {
      userNameSet = userNameSet.split("___")[0];
    }

    this.setState({
      firstname: userNameSet,
    });

    if (usersData?.audioChannel) {
      this.props.dispatch(setPrevPanning(usersData.audioChannel));
    }
    // stop outer functionality of make host
    // this.props.dispatch(setAutoMakeHostTrigger(false))

    if (usersData.currentSettingValue == usersData.prefSettingValue) {
      this.setState({ firstBufferDelay: true });
    } else if (usersData.currentSettingValue == usersData.defaultSettingValue) {
      this.setState({ secondBufferDelay: true });
    } else {
      this.setState({ thirdBufferDelay: true });
    }
    let _this = this;
    // Check if jisti to jamulus(hybrid session) process running

    setTimeout(function () {
      const { isHybridSession } = _this.props;
      if (!isHybridSession) {
        _this.checkHybridSession();
      } else {
        _this.setState({
          isHybridSessionActive: true,
        });
      }
    }, 500);

    setTimeout(function () {
      let { localUserName } = _this.props;
      //if (!localUserName) localUserName = "RTA User";
      // if (!localUserName) localUserName = getBaseConfig("userName");
      if (usersData.myName != localUserName) {
        _this.setState({
          firstname: localUserName,
        });
      }
    }, 1000);

    socketOn("hybrid_session_return", (data) => {
      const { localUser, dispatch } = this.props;
      if (
        data.location == CURRENT_ROOM_LOCATION &&
        localUser.id !== data.userId
      ) {
        this.setState({
          isHybridSessionActive: data.status,
        });

        dispatch(setHybridSession(data.status, "hybrid_session_return settings"));
        //DISABLE HYBRID BUTTON
        document.getElementById("hybrid-btn").disabled = true;

        setTimeout(() => {
          if (document.getElementById("hybrid-btn")) {
            if (document.getElementById("hybrid-btn").disabled == true) {
              //ENABLE HYBRID BUTTON
              document.getElementById("hybrid-btn").disabled = false;
            }
          }
        }, 15000);
      }
    });

    // Auto Manage Host Off

    // let selectAutoHostCheckbox = getBaseConfig('selectAutoHostCheckbox')
    // if (selectAutoHostCheckbox == true && outAutoManage && _isLiveStreamRunning == false && _isRecordingRunning == false) {
    //   if (clickedAutoMakeHost == false) {
    //   } else {
    //     this._selectAutoMakeHost({
    //       target: {
    //         checked: outAutoManage
    //       }
    //     }, "autoClick");
    //   }
    // } else if (selectAutoHostCheckbox == true && !outAutoManage && _isLiveStreamRunning == false && _isRecordingRunning == false) {
    //   this.setState({
    //     isAutoManageHostClicked: outAutoManage
    //   })
    // }

    // Auto Manage Host Off End

    // window.addEventListener('resize', this.getOrientation)
    window.matchMedia("(orientation: portrait)").addEventListener("change", e => {
      const portrait = e.matches;

      if (portrait) {
        this.getOrientation('portrait-primary');
      } else {
        this.getOrientation('landscape-primary');
      }
    });

  }

  componentDidUpdate(prevProps, prevState) {
    // isVoiceSync check is hybrid session running or not
    const {
      usersData,
      latencyData,
      hostTabData,
      hostReload,
      isVoiceSync,
      isConnectedAudioGhost,
      isHybridSession,
      clickedAutoMakeHost,
      audioChannelConfig,
      deviceUserName,
      _isLiveStreamRunning,
      _isRecordingRunning,
      autoManageHostTrigger,
    } = this.props;

    if (prevProps.usersData !== usersData) {
      if (usersData) {
        this.setState({
          profileName: "",
          instrumentName:
            usersData && usersData.instrument
              ? instrumentArray[usersData.instrument]
              : 0,
          device: "Jack",
          sliderLeftValue: usersData.sliderLeft,
          sliderRightValue: usersData.sliderRight,
          audioQuality:
            usersData.audioQuality == 0
              ? AUDIO_QUALITY_ZERO
              : usersData.audioQuality == 1
                ? AUDIO_QUALITY_ONE
                : AUDIO_QUALITY_TWO,
          isJitBuf: usersData.isJitBuf,
          isSmallNetworkEnable: usersData.isSmallNetworkEnable,
          currentSettingValue: usersData.currentSettingValue,
          prefSettingValue: usersData.prefSettingValue,
          defaultSettingValue: usersData.defaultSettingValue,
          safeSettingValue: usersData.defaultSetting,
          sliderPanValue: usersData.panLevel,
          sliderReverbValue: usersData.reverbLevel,
          leftReverb: usersData.leftReverb,
          rightReverb: !usersData.leftReverb,
          isAutoManageHostClicked: clickedAutoMakeHost,
        });
      }

      //MANAGE NEW USER CAME WHEN YOU ARE ON HOST TAB
      // if (hostReload && (prevProps.usersData.users.length !== usersData.users.length)) {
      //   setTimeout(() => {
      //     this.startHostTab();
      //   }, 1000);
      // }
    }

    if (usersData) {
      if (prevProps.audioChannelConfig != audioChannelConfig) {
        this.setState({
          audioChannel: AUDIO_CHANNEL_MODE[audioChannelConfig],
        });
      }
    }

    if (prevProps.hostTabData != hostTabData) {
      if (hostTabData) {
        this.setState({
          initialWait: false,
        });

        // Auto Manage Host Off

        // let selectAutoHostCheckbox = getBaseConfig('selectAutoHostCheckbox')
        // let isAutoManageHostClickedState = this?.state?.isAutoManageHostClicked
        // if (
        //   selectAutoHostCheckbox == true &&
        //   prevState?.isAutoManageHostClickedState != isAutoManageHostClickedState &&
        //   isAutoManageHostClickedState == true &&
        //   _isLiveStreamRunning == false &&
        //   _isRecordingRunning == false &&
        //   autoManageHostTrigger == false
        // ) {
        //   this._selectAutoMakeHost({
        //     target: {
        //       checked: isAutoManageHostClickedState
        //     }
        //   }, "autoClick");
        // }

        // Auto Manage Host Off End
      }
    }

    if (prevProps.latencyData !== latencyData) {
      if (!latencyData.jitterBuffer) {
        this.setState({ showJitterBuffer: latencyData.jitterBuffer });

        let count = this.state.dropCount + 1;
        this.setState({ dropCount: count });
      }

      //MANAGE CHART:
      if (latencyData.pingTime) {
        chartdataCount = chartdataCount + 1;
        let pingValue = latencyData.pingTime.split("ms");
        let overallValue = latencyData.delay.split("ms");
        let processValue = latencyData.processingDelay.split("ms");
        //this.setState({ dropCount: count, pingTimeChart: Number(pingValue[0])}); //RTACHART
        let newLatencyArr = this.state.chartdata;
        newLatencyArr.push([
          chartdataCount,
          Number(overallValue[0]),
          Number(pingValue[0]),
          Number(processValue[0]),
        ]);
        this.setState({ chartdata: newLatencyArr });
      }
      this.setState({ latencyData: latencyData });
      // if (usersData.myName != this.state.firstname) {
      //   if (usersData.uniqueID == localStorage.getItem("uniqueID")) {
      //     this.setState({
      //       firstname: usersData.myName
      //     })
      //   }
      // }
    }

    // if (prevProps.hostTabData !== hostTabData) {
    //   this.setState({ hostTabData: hostTabData.users });
    // }

    // :
    //const { isHybridSession } = this.props;
    if (prevProps.isHybridSession != isHybridSession) {
      this.setState({
        isHybridSessionActive: isHybridSession,
      });
    }

    // isConnectedAudioGhost == true &&
    if (prevProps.isConnectedAudioGhost !== isConnectedAudioGhost) {
      if (document.getElementById("hybrid-btn")) {
        //ENABLE HYBRID BUTTON
        document.getElementById("hybrid-btn").disabled = false;
      }
    }
    const { dispatch } = this.props;

    // if (isVoiceSync == !this.state.isHybridSessionActive) {
    //   const { roomorIpAddress, audioGhostId, dispatch } = this.props;
    //   let isIp = this._ValidateIPaddress(roomorIpAddress);
    //   this.hybridSessionStart(dispatch, roomorIpAddress, isIp, audioGhostId)
    // }
    // When ever user click on manage auto host, check in the existing host data if current user is recomended, if yes then show pop
    // if (prevProps.clickedAutoMakeHost != clickedAutoMakeHost) {
    //   if (clickedAutoMakeHost) {
    //     const { room, uniqueId, dispatch } = this.props;
    //     if (hostTabData?.users && hostTabData?.auto && usersData && room && uniqueId) {
    //       let newRecommended = hostTabData?.users.find(o => o.isRecommended == true);
    //       if (newRecommended && newRecommended?.uniqueId) {
    //         let iamIp = false;
    //         if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(room)) {
    //           iamIp = true;
    //         }
    //         if (!iamIp && usersData && usersData.isHost && newRecommended.uniqueId != usersData.uniqueId) {
    //           dispatch(setAutoMakeHost({
    //             //isAutoMakeHost: true,
    //             isAutoMakeModal: true,
    //             isAutoMakeHostUniqueId: newRecommended.uniqueId,
    //           }));
    //         } else if (iamIp && newRecommended.uniqueId == uniqueId) {
    //           dispatch(setAutoMakeHost({
    //             //isAutoMakeHost: true,
    //             isAutoMakeModal: true,
    //             isAutoMakeHostUniqueId: newRecommended.uniqueId,
    //           }));
    //         }
    //       }
    //     }
    //   }
    // }

    // Checkbox for manage auto host
    if (prevProps.clickedAutoMakeHost != clickedAutoMakeHost) {
      this.setState({
        isAutoManageHostClicked: clickedAutoMakeHost,
      });

      // dispatch(clickAutoMakeHost({ clickedAutoMakeHost: clickedAutoMakeHost }));

      if (clickedAutoMakeHost) {
        sessionStorage.setItem("uniqueID", localStorage.getItem("uniqueID"));
      } else {
        sessionStorage.removeItem("uniqueID");
      }
    }

    const { delayPanning, audioChannelSt, isStereoChanged } = this.props;
    if (
      prevProps.delayPanning != delayPanning ||
      prevProps.audioChannelSt?.audioIndex != audioChannelSt?.audioIndex
    ) {
      let mode = "";
      let value = "";
      if (
        delayPanning == PANNING_VAR.DELAY_PANNING ||
        delayPanning == PANNING_VAR.VOLUME_PANNING
      ) {
        mode = AUDIO_CHANNEL_ONE;
        value = 1;
      } else if (delayPanning == PANNING_VAR.NO_PANNING) {
        mode = AUDIO_CHANNEL_ZERO;
        value = 0;
      }

      if (mode && mode != this.state.audioChannel && isStereoChanged == false) {
        this.changeAudioChannel(
          {
            target: {
              name: "channel",
              value: value,
            },
          },
          0
        );
      }
    }

    if (prevProps.deviceUserName != deviceUserName) {
      var _this = this;
      setTimeout(async function () {
        let localName = deviceUserName || _this.props.localUserName;
        if (localName.indexOf("___") != -1) {
          localName = localName.split("___")[0];
        }
        _this.setState({
          firstname: localName,
        });
      }, 2000);
    }
  }

  componentWillUnmount() {
    dispatch(setOutAutoManage(this.state.isAutoManageHostClicked));
    this.setState({})
    // dispatch(setAutoMakeHostTrigger(true));
  }

  handleHostRefresh = () => {
    // const { roomorIpAddress, dispatch, hostTabData, usersData, isModerator } = this.props;
    // let willProceed = false;
    // let recHost = hostTabData?.users?.find(o => o.isRecommended == true);
    // let roomUrl;
    // if (roomorIpAddress.includes(":")) {
    //   roomUrl = roomorIpAddress.split(':');
    //   roomUrl = roomUrl[0];
    // }
    // let recPing = hostTabData?.users?.reduce(function (prev, curr) {
    //   let prevPing = prev.sumPing.split('ms');
    //   prevPing = Number(prevPing[0]);
    //   let currPing = curr.sumPing.split('ms');
    //   currPing = Number(currPing[0]);
    //   return prevPing < currPing ? prev : curr;
    // });
    // if (usersData.isHost) {
    //   willProceed = true;
    // } else if (this.state.isAddressIP && isModerator && (!recHost || recHost?.thirdParty)) {
    //   willProceed = true;
    // } else if (this.state.isAddressIP && recHost /*&& item.isRecommended*/) {
    //   if (recHost.uniqueId == usersData.uniqueId) {
    //     willProceed = true;
    //   } else {
    //     if (this.state.isAddressIP) {
    //       Toast(messages.notCurrentHostIp, Constant.App.ToastTime.LongCloseTime);
    //     } else {
    //       Toast(messages.notCurrentHost, Constant.App.ToastTime.LongCloseTime);
    //     }
    //     return false;
    //   }
    // } else {
    //   //alert("Only the current host can make this change.");
    //   if (this.state.isAddressIP) {
    //     if (this.state.isAddressIP && (!isModerator || !recHost)) {
    //       Toast(messages.notCurrentModIp, Constant.App.ToastTime.LongCloseTime);
    //     } else {
    //       Toast(messages.notCurrentHostIp, Constant.App.ToastTime.LongCloseTime);
    //     }
    //   } else {
    //     Toast(messages.notCurrentHost, Constant.App.ToastTime.LongCloseTime);
    //   }
    //   return false;
    // }
    // if (willProceed) {
    // let isIp = _ValidateIPaddress(roomorIpAddress);
    // const message = {
    //   action: {
    //     roomName: roomorIpAddress,
    //     isIp,
    //     reset: true
    //   },
    //   content: 'host-information',
    //   isBroadcast: true,
    //   sender: 'mobile'
    // };
    // this.sendDataToSocket(message);
    // sendAnalytics({
    //   action: 'host-information',
    //   source: "settings",
    //   category: "settings host-information"
    // });
    // dispatch(setHostRefresh(true));
    // dispatch(setHostRefreshTimer(true));
    // // SHOW/accessible refresh button after one min or when manage host data event received
    // setTimeout(function () {
    //   dispatch(setHostRefreshTimer(false));
    // }, (1000 * 60))
    // }
  };

  checkHybridSession = () => {
    const { dispatch, roomorIpAddress } = this.props;
    axios
      .get(
        Constant.App.ServerUrl +
        "/status-audio-route?&roomname=" +
        roomorIpAddress
      )
      .then((response) => {
        if (response.data.status) {
          if (response.data.processStatus) {
            dispatch(setHybridSession(true, "checkHybridSession"));
            this.setState({
              isHybridSessionActive: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log("checkHybridSession error =>", e);
      });
  };

  changeAudioQuality = ({ target: { name, value } }) => {
    this.setState({
      audioQuality: value,
    });
    let qualityIndex = 0;
    if (value == AUDIO_QUALITY_ZERO) {
      qualityIndex = 0;
    } else if (value == AUDIO_QUALITY_ONE) {
      qualityIndex = 1;
    } else if (value == AUDIO_QUALITY_TWO) {
      qualityIndex = 2;
    }

    const { usersData } = this.props;
    const message = {
      action: {
        uniqueID: usersData.uniqueId,
        audioQuality: qualityIndex,
      },
      content: "audio-quality",
      isBroadcast: true,
      sender: "mobile",
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: "",
      triggeredBy: "system",
      event: message.content,
      requestData: message,
      responseData: "",
      userId: "",
      boxId: message.action.uniqueID,
      message: "Emit to server",
    };
    SaveLog(log_data);
    //-------------------------------------------

    displayConsole("audio-quality", message);
    this.sendDataToSocket(message);
    sendAnalytics({
      action: "set-audio-quality",
      source: "settings",
      category: "settings audio-quality",
    });
  };

  changeAudioInterface = ({ target: { value } }) => {
    let intValue = 0;
    if (value) {
      intValue = parseInt(value);
    }
    const { usersData } = this.props;
    const message = {
      action: {
        uniqueID: usersData.uniqueId,
        audioInterface: intValue,
      },
      content: "audio-interface",
      isBroadcast: true,
      sender: "mobile",
    };
    this.sendDataToSocket(message);
  }

  closeAudioChannel = (type) => {
    let prevVolState = {
      mono: false,
    };
    prevVolState = Object.assign(type, prevVolState);
    this.setState({
      prevVolState,
    });
  };

  changeAudioChannel = ({ target: { name, value } }, isMenual = "") => {
    const { usersData, dispatch, delayPanning } = this.props;
    let isStereo = false;
    let audioIndex = 0;
    if (value == AUDIO_CHANNEL_ZERO) {
      audioIndex = 0;
      isStereo = false;
    } else if (value == AUDIO_CHANNEL_ONE) {
      audioIndex = 1;
      isStereo = false;
    } else if (value == AUDIO_CHANNEL_TWO) {
      audioIndex = 2;
      isStereo = true;
    }

    if (
      isMenual == 1 &&
      value != AUDIO_CHANNEL_ZERO &&
      delayPanning == PANNING_VAR.NO_PANNING
    ) {
      this.setState({
        prevVolState: {
          mono: true,
          mode: value,
        },
      });
      return false;
    }

    if (delayPanning == PANNING_VAR.DELAY_PANNING) {
      dispatch(setAudioChannelAdditionalSetting(true)); // check if user change the audio channel from the setting tab, check if delay panning enable. so, we need to disable the delay panning as well
    } else {
      dispatch(setAudioChannelAdditionalSetting(false)); // check if user change the audio channel from the setting tab, check if delay panning enable. so, we need to disable the delay panning as well
    }
    dispatch(setAudioStereo(isStereo)); // not hit the next event if set true (stop second call of audio-channel event )

    const message = {
      action: {
        uniqueID: usersData.uniqueId,
        audioChannel: audioIndex,
      },
      content: "audio-channel",
      isBroadcast: true,
      sender: "mobile",
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: "",
      triggeredBy: "system",
      event: message.content,
      requestData: message,
      responseData: "",
      userId: "",
      boxId: message.action.uniqueID,
      message: "Emit to server",
    };
    SaveLog(log_data);
    //-------------------------------------------

    displayConsole("audio-channel", message);
    this.sendDataToSocket(message);

    sendAnalytics({
      action: "set-audio-channels",
      source: "settings",
      category: "settings audio-channels",
    });
  };

  changeSliderLeft(value) {
    const { usersData } = this.props;
    this.setState({
      sliderLeftValue: value,
    });

    const message = {
      action: {
        sliderLeft: value,
        uniqueID: usersData.uniqueId,
      },
      content: "slider-left",
      isBroadcast: true,
      sender: "mobile",
    };

    let this_ = this;
    if (timeoutLeftFader) {
      clearTimeout(timeoutLeftFader);
    }
    timeoutLeftFader = setTimeout(function () {
      displayConsole("slider-left", message);

      //-------------Prepare logger data -------------
      var log_data = {
        functionName: "",
        triggeredBy: "system",
        event: message.content,
        requestData: message,
        responseData: "",
        userId: "",
        boxId: message.action.uniqueID,
        message: "Emit to server",
      };
      SaveLog(log_data);
      //-------------------------------------------

      this_.sendDataToSocket(message);
      sendAnalytics({
        action: "set-local-slider",
        source: "settings",
        category: "settings local slider",
      });
    }, 1500);
  }

  changeSliderRight(value) {
    const { usersData } = this.props;
    this.setState({
      sliderRightValue: value,
    });

    const message = {
      action: {
        sliderRight: value,
        uniqueID: usersData.uniqueId,
      },
      content: "slider-right",
      isBroadcast: true,
      sender: "mobile",
    };

    let this_ = this;
    if (timeoutRightFader) {
      clearTimeout(timeoutRightFader);
    }
    timeoutRightFader = setTimeout(function () {
      //-------------Prepare logger data -------------
      var log_data = {
        functionName: "",
        triggeredBy: "system",
        event: message.content,
        requestData: message,
        responseData: "",
        userId: "",
        boxId: message.action.uniqueID,
        message: "Emit to server",
      };
      SaveLog(log_data);
      //-------------------------------------------

      this_.sendDataToSocket(message);
      sendAnalytics({
        action: "set-server-slider",
        source: "settings",
        category: "settings server slider",
      });
    }, 1500);
  }

  _selectAutoMakeHost(e, action) {
    const {
      usersData,
      roomorIpAddress,
      dispatch,
      hostTabData,
      isRecording,
      isStreaming,
      uniqueId,
      isModerator,
      localUser,
      clickedAutoMakeHost,
      disableRecIcon,
      liveStreamingStatus
    } = this.props;

    if (!_ValidateIPaddress(CURRENT_ROOM_NAME)) {
      if ((isRecording && isRecording > 0) || disableRecIcon) {
        this.setState({
          isAutoManageHostClicked: false
        })
        // alert(Translate.messages.recordingToPause);
        dispatch(setConfirmationModalProps({
          isShow: true,
          title: ct("Translate.typography.alert"),
          content: ct("Translate.messages.recordingToPause"),
          cancelBtnName: false,
          cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
          successBtnName: ct("Translate.buttonTitle.okSmall"),
          onSuccess: () => {
            dispatch(setConfirmationModalProps({ isShow: false }));
          }
        }));
        return false;
      } else if ((isStreaming && isStreaming > 0) || liveStreamingStatus) {
        this.setState({
          isAutoManageHostClicked: false
        })
        // alert(Translate.messages.streamingToPause);
        dispatch(setConfirmationModalProps({
          isShow: true,
          title: ct("Translate.typography.alert"),
          content: ct("Translate.messages.streamingToPause"),
          cancelBtnName: false,
          cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
          successBtnName: ct("Translate.buttonTitle.okSmall"),
          onSuccess: () => {
            dispatch(setConfirmationModalProps({ isShow: false }));
          }
        }));
        return false;
      }
    }

    let roomUrl;
    let willMove = false;
    let checkboxStatus = e.target.checked;
    let recHost = hostTabData?.users?.find((o) => o.isRecommended == true);
    let thirdPartyRecHost = hostTabData?.users?.find(
      (o) => o.isRecommended == true && o.isThirdParty == true
    );
    let noChangedRoomName = getBaseConfig("noChangedRoomName");

    if (roomorIpAddress && roomorIpAddress.includes(":")) {
      roomUrl = roomorIpAddress.split(":");
      roomUrl = roomUrl[0];
    }

    // RTA_SINGLE_ROOM
    if (action == "manualClick") {
      const auto_host_data = {
        room: roomorIpAddress,
        autohost: checkboxStatus,
        location: CURRENT_ROOM_LOCATION,
        jitsiId: localUser?.id,
        actionByUser: localUser?.name,
        actionPerformed: "autoMakeHost",
        setFrom: "7",
      };
      socketEmit("auto_host", auto_host_data);
      this.setState({
        isAutoManageHostClicked: checkboxStatus,
      });
      const { dispatch } = this.props;

      dispatch(
        clickAutoMakeHost(
          { clickedAutoMakeHost: checkboxStatus },
          "settings _selectAutoMakeHost manualClick"
        )
      );

      if (checkboxStatus) {
        sessionStorage.setItem("uniqueID", localStorage.getItem("uniqueID"));
      } else {
        sessionStorage.removeItem("uniqueID");
      }
    }

    if (action == "autoClick") {
      if (noChangedRoomName == true) {
        let validIpRoom = _ValidateIPaddress(roomorIpAddress);
        let validIpRoomUrl = roomorIpAddress;
        if (validIpRoomUrl && validIpRoomUrl.includes(":")) {
          validIpRoomUrl = validIpRoomUrl.split(":");
          validIpRoomUrl = validIpRoomUrl[0];
        }
        if (
          checkboxStatus &&
          thirdPartyRecHost &&
          validIpRoom &&
          validIpRoomUrl == thirdPartyRecHost?.thirdParty
        ) {
          willMove = false;
        } else if (
          checkboxStatus &&
          thirdPartyRecHost &&
          validIpRoomUrl != thirdPartyRecHost?.thirdParty
        ) {
          const auto_host_data = {
            room: roomorIpAddress,
            autohost: checkboxStatus,
            location: CURRENT_ROOM_LOCATION,
            setFrom: "9",
          };
          socketEmit("auto_host", auto_host_data);
          this.sendNewRoom(thirdPartyRecHost.thirdParty);
        } else {
          willMove = true;
        }
      } else {
        if (
          checkboxStatus &&
          thirdPartyRecHost &&
          this.state.isAddressIP &&
          roomUrl == thirdPartyRecHost?.thirdParty
        ) {
          willMove = false;
        } else if (
          checkboxStatus &&
          thirdPartyRecHost &&
          roomUrl != thirdPartyRecHost?.thirdParty
        ) {
          const auto_host_data = {
            room: roomorIpAddress,
            autohost: checkboxStatus,
            location: CURRENT_ROOM_LOCATION,
            setFrom: "10",
          };
          socketEmit("auto_host", auto_host_data);
          this.sendNewRoom(thirdPartyRecHost.thirdParty);
        } else {
          willMove = true;
        }
      }
    }

    // if (!this.state.isAddressIP && usersData?.isHost) {
    //   willMove = true
    // } else if (this.state.isAddressIP && isModerator && (!recHost || recHost?.thirdParty)) {
    //   willMove = true;
    // } else if (this.state.isAddressIP && recHost) {
    //   if (recHost?.uniqueId == usersData.uniqueId) {
    //     willMove = true;
    //   }
    // }
    // if (recHost) {
    // if ((!this.state.isAddressIP
    //   && usersData?.isHost)
    //   || (this.state.isAddressIP
    //     && recHost
    //     && recHost?.uniqueId == usersData.uniqueId)) {
    if (willMove) {
      // const eventStatus = checkboxStatus;
      this.setState({
        isAutoManageHostClicked: checkboxStatus,
      });
      const { clickedAutoMakeHost, dispatch } = this.props;

      dispatch(
        clickAutoMakeHost(
          { clickedAutoMakeHost: checkboxStatus },
          "settings _selectAutoMakeHost willMove"
        )
      );

      if (checkboxStatus) {
        sessionStorage.setItem("uniqueID", localStorage.getItem("uniqueID"));
      } else {
        sessionStorage.removeItem("uniqueID");
      }

      const auto_host_data = {
        room: roomorIpAddress,
        autohost: checkboxStatus,
        location: CURRENT_ROOM_LOCATION,
        setFrom: "11",
      };
      socketEmit("auto_host", auto_host_data);
      var _this = this;
      setTimeout(function () {
        _this.setState({
          makeHostUniqueId: recHost?.uniqueId,
        });
        selectedUniqueId = recHost?.uniqueId;
        if (checkboxStatus) {
          if (
            !_this.state.isAddressIP &&
            usersData &&
            usersData.isHost &&
            recHost?.uniqueId != uniqueId
          ) {
            selectedUniqueId = recHost?.uniqueId;
            if (selectedUniqueId) {
              _this.callmakehostApi();
            }
          } else if (_this.state.isAddressIP && recHost) {
            if (recHost?.uniqueId == usersData.uniqueId) {
              if (noChangedRoomName == true) {
                _this.sendNewRoom(CURRENT_ROOM_NAME);
              } else {
                _this.setState({
                  showNewRoomModal: true,
                });
              }
            }
          }
        }
      }, 1000);
    } else {
      // let makeInput = document.getElementById("make-host-input");
      // if (makeInput) {
      //   makeInput.checked = false;
      // }
      // if (this.state.isAddressIP) {
      //   if (this.state.isAddressIP && (!isModerator || !recHost)) {
      //     Toast(messages.notCurrentModIp, Constant.App.ToastTime.LongCloseTime);
      //   } else {
      //     Toast(messages.notCurrentHostIp, Constant.App.ToastTime.LongCloseTime);
      //   }
      // } else {
      //   Toast(messages.notCurrentHost, Constant.App.ToastTime.LongCloseTime);
      // }
      // Toast(messages.notCurrentHost, Constant.App.ToastTime.LongCloseTime);
      return false;
    }
    // }
    // else {
    //   document.getElementById("make-host-input").checked = false;
    //   Toast(messages.notCurrentHost, Constant.App.ToastTime.LongCloseTime);
    //   return false;
    // }
    // this.setState({
    //   isAutoManageHostClicked: !this.state.isAutoManageHostClicked,
    // })
    // const { clickedAutoMakeHost, dispatch } = this.props;
    // dispatch(clickAutoMakeHost({ clickedAutoMakeHost: !clickedAutoMakeHost }));
    sendAnalytics({
      action: "automanage-host-checkbox",
      source: "settings",
      category: "settings automanage host checkbox",
    });
  }

  _handleJitBufferMethod(value) {
    displayConsole("jitter-buffer value", value);
    const { usersData } = this.props;
    const message = {
      action: {
        uniqueID: usersData.uniqueId,
        isJitBuf: !value,
      },
      content: "jit-buf",
      isBroadcast: true,
      sender: "mobile",
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: "",
      triggeredBy: "system",
      event: message.content,
      requestData: message,
      responseData: "",
      userId: "",
      boxId: message.action.uniqueID,
      message: "Emit to server",
    };
    SaveLog(log_data);
    //-------------------------------------------

    this.sendDataToSocket(message);
    sendAnalytics({
      action: "jit-buffer",
      source: "settings",
      category: "settings jitter buffer",
    });
  }

  _handleEnableNetwork(value) {
    displayConsole("small-network value", value);
    const { usersData } = this.props;
    const message = {
      action: {
        uniqueID: usersData.uniqueId,
        isSmallNetworkEnable: !value,
      },
      content: "small-network",
      isBroadcast: true,
      sender: "mobile",
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: "",
      triggeredBy: "system",
      event: message.content,
      requestData: message,
      responseData: "",
      userId: "",
      boxId: message.action.uniqueID,
      message: "Emit to server",
    };
    SaveLog(log_data);
    //-------------------------------------------

    this.sendDataToSocket(message);
  }

  updateProfile = (event) => {
    let { value } = event.target;
    if (value) {
      value = value.substring(0, USER_NAME_LEN);
    }
    const { usersData, dispatch } = this.props;
    this.setState({
      firstname: value,
    });
    localStorage.setItem("firstname", value);
    if (timeoutProfileName) {
      clearTimeout(timeoutProfileName);
    }
    let this_ = this;
    timeoutProfileName = setTimeout(function () {
      var message = {
        action: {
          firstname: value,
          lastname: "",
          uniqueID: usersData.uniqueId,
        },
        content: "set-name",
        isBroadcast: true,
        sender: "mobile",
      };

      //-------------Prepare logger data -------------
      var log_data = {
        functionName: "",
        triggeredBy: "system",
        event: message.content,
        requestData: message,
        responseData: "",
        userId: "",
        boxId: message.action.uniqueID,
        message: "Emit to server",
      };
      SaveLog(log_data);
      //-------------------------------------------

      this_.sendDataToSocket(message);
      sendAnalytics({
        action: "set-name",
        source: "settings",
        category: "settings user name",
      });
    }, 1500);

    if (value == "") {
      // value = "RTA User";
      // value = filterRemoteParticipant();
    }

    //SET DECODED USERNAME & EMAIL IN HIS SETTINGS
    // dispatch(participantUpdated({
    //   // conference: oneclick_room_id,
    //   // id: jitsiUserId,
    //   name: value,
    //   //email: email
    // }));

    // SET DECODED USERNAME IN REMOTE USER WINDOW
    dispatch(
      updateSettings({
        displayName: value,
      }, '13')
    );
  };

  getIndex(value) {
    for (var i = 0; i < instrumentArray.length; i++) {
      if (instrumentArray[i] === value) {
        return i;
      }
    }
    return -1;
  }

  updateInstrument = (event) => {
    const { name, value } = event.target;
    this.setState({
      instrumentName: value,
    });
    localStorage.setItem("instrumentName", value);

    const { usersData } = this.props;
    const data = {
      action: {
        instrument: this.getIndex(value),
        uniqueID: usersData.uniqueId,
      },
      content: "set-instrument",
      isBroadcast: true,
      sender: "mobile",
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: "",
      triggeredBy: "system",
      event: data.content,
      requestData: data,
      responseData: "",
      userId: "",
      boxId: data.action && data.action.uniqueID ? data.action.uniqueID : "",
      message: "Emit to server",
    };
    SaveLog(log_data);
    //-------------------------------------------

    displayConsole("setInstrument", data);
    this.sendDataToSocket(data);
    sendAnalytics({
      action: "set-instrument",
      source: "settings",
      category: "settings instrument name",
    });
  };

  showAlert = (bufferValue) => {
    const {
      usersData,
      dispatch,
      roomorIpAddress,
      isHybridSession,
      isRecording,
      isStreaming,
      disableRecIcon,
      liveStreamingStatus
    } = this.props;

    if (_ValidateIPaddress(CURRENT_ROOM_NAME)) {
      if ((isRecording && isRecording > 0) || disableRecIcon) {
        this.setState({
          isAutoManageHostClicked: false
        })
        // alert(Translate.messages.recordingToPauseForAudio);
        dispatch(setConfirmationModalProps({
          isShow: true,
          title: ct("Translate.typography.alert"),
          content: ct("Translate.messages.recordingToPauseForAudio"),
          cancelBtnName: false,
          cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
          successBtnName: ct("Translate.buttonTitle.okSmall"),
          onSuccess: () => {
            dispatch(setConfirmationModalProps({ isShow: false }));
          }
        }));
        return false;
      } else if ((isStreaming && isStreaming > 0) || liveStreamingStatus) {
        this.setState({
          isAutoManageHostClicked: false
        })
        // alert(Translate.messages.streamingToPauseForAudio);
        dispatch(setConfirmationModalProps({
          isShow: true,
          title: ct("Translate.typography.alert"),
          content: ct("Translate.messages.streamingToPauseForAudio"),
          cancelBtnName: false,
          cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
          successBtnName: ct("Translate.buttonTitle.okSmall"),
          onSuccess: () => {
            dispatch(setConfirmationModalProps({ isShow: false }));
          }
        }));
        return false;
      }
    }

    // User can't change if current value and new value
    if (usersData.currentSettingValue == bufferValue) {
      return false;
    }

    let msg = ct("rta-trmc.mixer.rebootDeviceMsg");

    let hideLoading = false;
    if (usersData.hasOwnProperty("isUbuntu")) {
      if (usersData.isUbuntu) {
        hideLoading = true;
        msg = i18next.t("rta-trmc.mixer.isUbuntuBufferChangeMsg", { range: bufferValue });
      }
    }

    dispatch(setConfirmationModalProps({
      isShow: true,
      title: ct("Translate.typography.confirmation"),
      successBtnName: ct("Translate.buttonTitle.okSmall"),
      cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
      content: msg,
      onSuccess: () => {
        dispatch(setIsEventRequestingLoader("bufferDelayChange"));
        setTimeout(function () {
          dispatch(setIsEventRequestingLoader(''))
        }, 60000)

        this.props.onClose();

        if (usersData.isHost == true) {
          dispatch(showApiLoader())
          dispatch(setIsBufferChange(true));


          if (hideLoading) {
            dispatch(setIsEventRequestingLoader(''))
            dispatch(setIsBufferChange(false));
            setTimeout(function () {
              dispatch(hideApiLoader())
            }, 2000)
          } else {
            // Re-hit show loader so loaders don't break
            setTimeout(function () {
              dispatch(showApiLoader())
            }, 2000)
            setTimeout(function () {
              dispatch(showApiLoader())
            }, 4000)
            // End
          }

          if (!_ValidateIPaddress(CURRENT_ROOM_NAME) && usersData.hasOwnProperty("isUbuntu") && usersData.isUbuntu) {
            const data = {
              action: {
                delay: bufferValue,
                uniqueID: usersData.uniqueId,
              },
              content: "buffer-delay",
              isBroadcast: true,
              sender: "mobile",
            };

            this.sendDataToSocket(data, {
              loaderAdditionalDetail: ct("Translate.messages.bufferDelayProcessing"),
              type: 2,
            });

          } else {
            setTimeout(function () {
              dispatch(
                getBufferDelayApi({
                  roomName: roomorIpAddress,
                  hostId: usersData.uniqueId,
                  delay: bufferValue,
                })
              );
            }, 1000);
          }


          setTimeout(() => {
            dispatch(setIsBufferChange(false));
          }, 30000);
          // setTimeout(function () {
          //   dispatch(hideApiLoader())
          // }, 20000)

          // buffer value set to true as in this case buffer value was undefined
          const bufferData = {
            isBuffer: true,
          };
          dispatch(setBufferValue(bufferData));
        } else {

          // Stop audio route when user change buffer delay
          // if (isHybridSession) {
          //   axios.get(Constant.App.ServerUrl + '/stop-audio-route?roomname=' + roomorIpAddress + "&processtype=routing")
          // }

          const bufferData = {
            isBuffer: true,
          };
          dispatch(setBufferValue(bufferData));
          dispatch(setHostInitWait(true));

          //BUFFER VALUE AUTOCONNECT VARIABLES
          localStorage.removeItem("makeHost");
          localStorage.setItem("autoConnect", "true");
          let noChangedRoomName = getBaseConfig("noChangedRoomName");
          if (noChangedRoomName == true) {
            dispatch(setLocalAutoConnect(true));
          }
          localStorage.setItem("uniqueID", usersData.uniqueId);

          const data = {
            action: {
              delay: bufferValue,
              uniqueID: usersData.uniqueId,
            },
            content: "buffer-delay",
            isBroadcast: true,
            sender: "mobile",
          };

          // displayConsole('bufferdata --->> ', data);
          // this.sendDataToSocket(data);

          //-------------Prepare logger data -------------
          var log_data = {
            functionName: "",
            triggeredBy: "system",
            event: data.content,
            requestData: data,
            responseData: "",
            userId: "",
            boxId: data.action.uniqueID,
            message: "Emit to server",
          };
          SaveLog(log_data);
          //-------------------------------------------
          this.sendDataToSocket(data, {
            loaderAdditionalDetail: ct("Translate.messages.bufferDelayProcessing"),
            type: 2,
          });
          if (hideLoading) {
            dispatch(setIsEventRequestingLoader(''))
            dispatch(setIsBufferChange(false));
            setTimeout(function () {
              dispatch(
                hideApiLoader({
                  loading: false,
                })
              );
            }, 2000)
            // localStorage.removeItem("bufferValue");
            dispatch(setLocalBufferValue(false));
          } else {
            dispatch(setLocalBufferValue(true));
            // localStorage.setItem("bufferValue", true);
          }
          sendAnalytics({
            action: "set-buffer-delay",
            source: "settings",
            category: "buffer-delay",
          });
        }

        dispatch(setConfirmationModalProps({ isShow: false }));
      },
      onCancel: () => {
        dispatch(setConfirmationModalProps({ isShow: false }));
      }
    }));
  };

  stopLatencyonTabChange = () => {
    const { dispatch, usersData } = this.props;

    //MANAGE CHART:
    chartdataCount = 0;
    //CLEAR CHART ARRAY
    this.setState({
      chartdata: [
        [ct("rta-trmc.mixer.x"), ct("rta-trmc.mixer.overallDelay"), ct("rta-trmc.mixer.pingTime"), ct("rta-trmc.mixer.processingDelay")],
        [0, 0, 0, 0],
      ],
    });

    const data = {
      action: {
        uniqueID: usersData.uniqueId,
      },
      content: "stop-latency",
      isBroadcast: true,
      sender: "mobile",
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: "",
      triggeredBy: "system",
      event: data.content,
      requestData: data,
      responseData: "",
      userId: "",
      boxId: data.action.uniqueID,
      message: "Emit to server",
    };
    SaveLog(log_data);
    //-------------------------------------------

    this.sendDataToSocket(data);
  };

  startLatency = () => {
    this.closeHostTab();

    this.setState({ dropCount: 0, pingTimeChart: 0 });
    const { usersData } = this.props;

    const data = {
      action: {
        uniqueID: usersData.uniqueId,
      },
      content: "start-latency",
      isBroadcast: true,
      sender: "mobile",
    };

    //-------------Prepare logger data -------------
    var log_data = {
      functionName: "",
      triggeredBy: "system",
      event: data.content,
      requestData: data,
      responseData: "",
      userId: "",
      boxId: data.action.uniqueID,
      message: "Emit to server",
    };
    SaveLog(log_data);
    //-------------------------------------------

    this.sendDataToSocket(data);
    sendAnalytics({
      action: "start-latency",
      source: "settings",
      category: "settings start-latency",
    });
  };

  // NOT IN USE:
  startHostTab = () => {
    // STOP LATENCY ON CLICKING OTHER TAB
    this.stopLatencyonTabChange();
    // const { usersData, roomorIpAddress, dispatch } = this.props;
    // //manage variable to call close host tab event
    // dispatch(setHostTabData({
    //   hostRcvResponse: false,
    // }));
    // dispatch(setHostTabReload({
    //   hostReload: true
    // }));

    // let data = {
    //     action: {
    //       roomName: roomorIpAddress
    //     },
    //     content: 'host-information',
    //     isBroadcast: true,
    //     sender: 'mobile'
    // }
    // if(this.state.isAddressIP) {
    //   data.action.isIp = true
    // }
    // this.sendDataToSocket(data);
  };

  closeHostTab = () => {
    // STOP LATENCY ON CLICKING OTHER TAB
    this.stopLatencyonTabChange();
    this.setState({ showHostRefresh: false });
    // const { usersData, roomorIpAddress, hostTabData, dispatch } = this.props;
    // if(hostTabData && hostTabData != undefined && hostTabData !==null) {
    //   if(hostTabData.hostRcvResponse == false) {
    //     const data = {
    //       action: {
    //         roomName: roomorIpAddress
    //       },
    //       content: 'cancel-host-information',
    //       isBroadcast: true,
    //       sender: 'mobile'
    //     }
    //     //manage variable to call close host tab event
    //     dispatch(setHostTabData({ hostRcvResponse: true }));
    //     dispatch(setHostTabReload({ hostReload: false }));
    //     this.sendDataToSocket(data);
    //   }
    // }
  };

  closeHostTabExtra = () => {
    this.setState({ showHostRefresh: true });
    this.stopLatencyonTabChange();
  };

  makeHost = (item) => {
    const {
      usersData,
      roomorIpAddress,
      dispatch,
      hostTabData,
      isRecording,
      isStreaming,
      isModerator,
      localUser,
      disableRecIcon,
      liveStreamingStatus
    } = this.props;

    if (!_ValidateIPaddress(CURRENT_ROOM_NAME)) {
      if ((isRecording && isRecording > 0) || disableRecIcon) {
        this.setState({
          isAutoManageHostClicked: false
        })
        // alert(Translate.messages.recordingToPauseForHost);
        dispatch(setConfirmationModalProps({
          isShow: true,
          title: ct("Translate.typography.alert"),
          content: ct("Translate.messages.recordingToPauseForHost"),
          cancelBtnName: false,
          cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
          successBtnName: ct("Translate.buttonTitle.okSmall"),
          onSuccess: () => {
            dispatch(setConfirmationModalProps({ isShow: false }));
          }
        }));
        return false;
      } else if ((isStreaming && isStreaming > 0) || liveStreamingStatus) {
        this.setState({
          isAutoManageHostClicked: false
        })
        // alert(Translate.messages.streamingToPauseForHost);
        dispatch(setConfirmationModalProps({
          isShow: true,
          title: ct("Translate.typography.alert"),
          content: ct("Translate.messages.streamingToPauseForHost"),
          cancelBtnName: false,
          cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
          successBtnName: ct("Translate.buttonTitle.okSmall"),
          onSuccess: () => {
            dispatch(setConfirmationModalProps({ isShow: false }));
          }
        }));
        return false;
      }
    }

    dispatch(setIsEventRequestingLoader("manualMakeHost"));

    // To avoid loader being hide when make host is clicked
    setTimeout(function () {
      dispatch(setIsEventRequestingLoader(""));
    }, 60000);

    // const autoHostStorageData = {
    //   autoHost: false,
    //   timeStamp: Math.round(new Date().getTime() / 1000)
    // }
    // localStorage.setItem('autoHostCheckbox', JSON.stringify(autoHostStorageData))

    dispatch(
      clickAutoMakeHost({ clickedAutoMakeHost: false }, "settings makeHost")
    );

    const auto_host_data = {
      room: roomorIpAddress,
      autohost: false,
      location: CURRENT_ROOM_LOCATION,
      jitsiId: localUser?.id,
      actionByUser: localUser?.name,
      actionPerformed: "manualMakeHost",
      setFrom: "12",
    };
    socketEmit("auto_host", auto_host_data);

    // Rights for all users to click on make host
    selectedUniqueId = item?.uniqueId;
    this.setState({
      makeHostUniqueId: item?.uniqueId,
      isAutoManageHostClicked: false,
    });

    if (this.state.isAddressIP) {
      if (item.thirdParty) {
        this.sendNewRoom(item.thirdParty);
      } else {
        let noChangedRoomName = getBaseConfig("noChangedRoomName");
        if (noChangedRoomName == true) {
          this.sendNewRoom(CURRENT_ROOM_NAME);
        } else {
          this.setState({ showNewRoomModal: true });
        }
      }
    } else {
      if (item.thirdParty) {
        this.sendNewRoom(item.thirdParty);
      } else {
        this.callmakehostApi();
      }
    }
    //End

    // if (usersData.isHost && item.thirdParty) {
    //   this.sendNewRoom(item.thirdParty);
    // } else {

    //   //SET SELECTED USER'S UNIQUE DEVICE ID IN STATE
    //   // this.setState({ selectedUniqueId: item.uniqueId});
    //   selectedUniqueId = item.uniqueId;

    //   this.setState({
    //     makeHostUniqueId: item.uniqueId
    //   })

    //   let recHost = hostTabData?.users?.find(o => o.isRecommended == true);
    //   if (usersData.isHost) {
    //     this.callmakehostApi();
    //   } else if (this.state.isAddressIP && isModerator && (!recHost || recHost?.thirdParty)) {
    //     if (item.thirdParty) {
    //       this.sendNewRoom(item.thirdParty);
    //     } else {
    //       this.setState({ showNewRoomModal: true });
    //     }
    //   } else if (this.state.isAddressIP && recHost /*&& item.isRecommended*/) {
    //     if (recHost.uniqueId == usersData.uniqueId) {
    //       if (item.thirdParty) {
    //         this.sendNewRoom(item.thirdParty);
    //       } else {
    //         this.setState({ showNewRoomModal: true });
    //       }
    //     } else {
    //       if (this.state.isAddressIP) {
    //         Toast(messages.notCurrentHostIp, Constant.App.ToastTime.LongCloseTime);
    //       } else {
    //         Toast(messages.notCurrentHost, Constant.App.ToastTime.LongCloseTime);
    //       }
    //       return false;
    //     }
    //   } else {
    //     if (this.state.isAddressIP) {
    //       if (this.state.isAddressIP && (!isModerator || !recHost)) {
    //         Toast(messages.notCurrentModIp, Constant.App.ToastTime.LongCloseTime);
    //       } else {
    //         Toast(messages.notCurrentHostIp, Constant.App.ToastTime.LongCloseTime);
    //       }
    //     } else {
    //       Toast(messages.notCurrentHost, Constant.App.ToastTime.LongCloseTime);
    //     }
    //     return false;
    //   }
    // }
    sendAnalytics({
      action: "make-host",
      source: "settings",
      category: "settings make-host",
    });
  };

  callThirdPartyMakeHostApi(newRoomName) {
    const { roomorIpAddress, dispatch } = this.props;

    dispatch(
      showApiLoader({
        loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
      })
    );

    dispatch(
      thirdPartyMakeHostApi({
        roomName: roomorIpAddress,
        newRoomName: newRoomName,
        visibleRoom: CURRENT_ROOM_NAME
      }).then((res) => {
        if (res.status == 1) {
        } else {
          dispatch(hideApiLoader());
        }
        return false;
      })
    );
  }

  callmakehostApi(newRoomName) {
    const { roomorIpAddress, dispatch } = this.props;
    dispatch(
      showApiLoader({
        loaderAdditionalDetail: ct("Translate.messages.makeHostConnecting"),
      })
    );
    // UPDATE REDUCER FOR GHOST VOICESYNC:
    // dispatch(setGhostVoiceSync(false));

    // if (selectedUniqueId == '') {
    //   selectedUniqueId = this.state.makeHostUniqueId;
    // }

    let url = `${Constant.App.ServerUrl}/make-host?room=${roomorIpAddress}&newhost=${selectedUniqueId}`;
    let noChangedRoomName = getBaseConfig("noChangedRoomName");
    if (noChangedRoomName == true && newRoomName) {
      url = `${Constant.App.ServerUrl
        }/make-host?room=${roomorIpAddress}&newhost=${selectedUniqueId}&newRoomName=${newRoomName}&visibleRoom=${CURRENT_ROOM_NAME}`;
    } else if (noChangedRoomName == true) {
      url = `${Constant.App.ServerUrl
        }/make-host?room=${roomorIpAddress}&newhost=${selectedUniqueId}&visibleRoom=${CURRENT_ROOM_NAME}`;
    } else if (newRoomName) {
      url = `${Constant.App.ServerUrl}/make-host?room=${roomorIpAddress}&newhost=${selectedUniqueId}&newRoomName=${newRoomName}`;
    }

    axios
      .get(url)
      .then((response) => {
        let noChangedRoomName = getBaseConfig("noChangedRoomName");
        if (noChangedRoomName == true && newRoomName) {
          if (_ValidateIPaddress(newRoomName)) {
            if (newRoomName && newRoomName.indexOf("_") != -1) {
              newRoomName = newRoomName.replace("_", ":");
            }
          }
          dispatch(setRoomorIpAddress(newRoomName, "settings callmakehostApi"));
        } else if (noChangedRoomName == true) {
          dispatch(
            setRoomorIpAddress(roomorIpAddress, "settings callmakehostApi")
          );
        }
        // if (response.data.status) {
        //   //dispatch(setclickMakeHost(true));
        // } else {
        return false;
        //}
      })
      .catch((error) => {
        console.log("Make Host API error =>", error);
        dispatch(hideApiLoader());
      });
  }

  setNewRoom = (event) => {
    try {
      let roomFound = event.target.value.toLowerCase();
      this.setState({
        ipNewroom: roomFound,
      });
    } catch (e) {
      console.log("setNewRoom error =>", e);
    }
  };

  sendNewRoom = (thirdParty) => {
    const { roomorIpAddress } = this.props;
    let _new_room;
    let noChangedRoomName = getBaseConfig("noChangedRoomName");
    if (thirdParty != 1) {
      _new_room = thirdParty;
    } else {
      _new_room = this.state.ipNewroom;
      _new_room = _new_room.toLowerCase().replaceAll(/\s/g, "").trim();
    }

    let canCheckRoom = true;

    if (getBaseConfig("makeHostChangeRoom") == false) {
      canCheckRoom = false;
    }

    axios
      .get(`${socket_endpoint + apiVersion}/roomStatus?room=${_new_room}`)
      .then((response) => {
        if (canCheckRoom) {
          if (response && response.data && response.data.status) {
            Toast(
              ct("messages.enteredClaimedRoom", "messages"),
              Constant.App.ToastTime.LongCloseTime
            );
            return false;
          }
        }

        if (thirdParty && noChangedRoomName == true) {
          if (_ValidateIPaddress(_new_room)) {
            this.callThirdPartyMakeHostApi(_new_room);
          } else if (!_ValidateIPaddress(_new_room)) {
            this.callmakehostApi(_new_room);
          }
        } else if (_new_room.includes(".")) {
          if (thirdParty) {
            this.callThirdPartyMakeHostApi(_new_room);
          } else {
            Toast(
              ct("messages.invalidNumericRoom", "messages"),
              Constant.App.ToastTime.LongCloseTime
            );
            return false;
          }
        } else if (_new_room.includes(".melomax.cloud")) {
          (async () => {
            var response = await fetch(
              "https://dns.google/resolve?name=" + _new_room
            );
            var json = await response.json();
            if (json && json.Answer) {
              _new_room = json.Answer[0].data;
              if (_ValidateIPaddress(_new_room) && _new_room != "1.1.1.1") {
                // dispatch(getipListFromApi());
                // JOIN ROOM WITHOUT FINDING IN LIST
                this.callmakehostApi(_new_room);
              } else {
                //setTimeout(function () {
                Toast(ct("messages.invalidIp", "messages"), Constant.App.ToastTime.LongCloseTime);
                return false;
                //}, 100)
              }
            }
          })();
        } else if (isNumeric(_new_room)) {
          Toast(
            ct("messages.invalidNumericRoom", "messages"),
            Constant.App.ToastTime.LongCloseTime
          );
          return false;
        } else if (_new_room.length > 20) {
          Toast(
            ct("messages.invalidRoomLength", "messages"),
            Constant.App.ToastTime.LongCloseTime
          );
          return false;
        } else if (_new_room.length < 1) {
          Toast(
            ct("messages.roomnameRequired", "messages"),
            Constant.App.ToastTime.LongCloseTime
          );
          return false;
        } else if (_new_room == roomorIpAddress) {
          Toast(ct("messages.enterDiffRoom", "messages"), Constant.App.ToastTime.LongCloseTime);
          return false;
        } else {
          sessionStorage.setItem("foundRoomName", _new_room);
          this.callmakehostApi(_new_room);
        }
      })
      .catch((error) => {
        console.log("Invalid Cliamed Room Request Found =>", error);
      });
  };

  // sendDataToSocket(message) {
  // sendData(message);
  sendDataToSocket(message, additional = "") {
    sendData(message, additional);
  }

  // VALIDATE IP ADDRESS
  _ValidateIPaddress(ipaddress) {
    if (
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        ipaddress
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  changeSliderPan(value) {
    const { usersData } = this.props;
    this.setState({
      sliderPanValue: value,
    });

    const message = {
      action: {
        panValue: value,
        uniqueID: usersData.uniqueId,
      },
      content: "set-pan",
      isBroadcast: true,
      sender: "mobile",
    };
    displayConsole("set-pan", message);

    let this_ = this;
    if (timeoutLeftFader) {
      clearTimeout(timeoutLeftFader);
    }
    timeoutLeftFader = setTimeout(function () {
      //-------------Prepare logger data -------------
      var log_data = {
        functionName: "",
        triggeredBy: "system",
        event: message.content,
        requestData: message,
        responseData: "",
        userId: "",
        boxId: message.action.uniqueID,
        message: "Emit to server",
      };
      SaveLog(log_data);
      //-------------------------------------------

      this_.sendDataToSocket(message);
    }, 1500);
  }

  changeSliderReverb(value) {
    const { usersData } = this.props;
    this.setState({
      sliderReverbValue: value,
    });

    const message = {
      action: {
        leftValue: this.state.leftReverb,
        reverbValue: value,
        uniqueID: usersData.uniqueId,
      },
      content: "set-reverb",
      isBroadcast: true,
      sender: "mobile",
    };
    displayConsole("set-reverb", message);

    let this_ = this;
    if (timeoutRightFader) {
      clearTimeout(timeoutRightFader);
    }
    timeoutRightFader = setTimeout(function () {
      //-------------Prepare logger data -------------
      var log_data = {
        functionName: "",
        triggeredBy: "system",
        event: message.content,
        requestData: message,
        responseData: "",
        userId: "",
        boxId: message.action.uniqueID,
        message: "Emit to server",
      };
      SaveLog(log_data);
      //-------------------------------------------

      this_.sendDataToSocket(message);
    }, 1500);
  }

  changeReverbLeftRadio() {
    const { usersData } = this.props;
    this.setState({
      leftReverb: true,
      rightReverb: false,
    });

    const message = {
      action: {
        leftValue: true,
        reverbValue: this.state.sliderReverbValue,
        uniqueID: usersData.uniqueId,
      },
      content: "set-reverb",
      isBroadcast: true,
      sender: "mobile",
    };
    displayConsole("set-reverb", message);

    let this_ = this;
    if (timeoutRightFader) {
      clearTimeout(timeoutRightFader);
    }
    timeoutRightFader = setTimeout(function () {
      //-------------Prepare logger data -------------
      var log_data = {
        functionName: "",
        triggeredBy: "system",
        event: message.content,
        requestData: message,
        responseData: "",
        userId: "",
        boxId: message.action.uniqueID,
        message: "Emit to server",
      };
      SaveLog(log_data);
      //-------------------------------------------

      this_.sendDataToSocket(message);
    }, 1500);
  }

  changeReverbRigtRadio() {
    const { usersData } = this.props;
    this.setState({
      rightReverb: true,
      leftReverb: false,
    });

    const message = {
      action: {
        leftValue: false,
        reverbValue: this.state.sliderReverbValue,
        uniqueID: usersData.uniqueId,
      },
      content: "set-reverb",
      isBroadcast: true,
      sender: "mobile",
    };
    displayConsole("set-reverb", message);

    let this_ = this;
    if (timeoutRightFader) {
      clearTimeout(timeoutRightFader);
    }
    timeoutRightFader = setTimeout(function () {
      //-------------Prepare logger data -------------
      var log_data = {
        functionName: "",
        triggeredBy: "system",
        event: message.content,
        requestData: message,
        responseData: "",
        userId: "",
        boxId: message.action.uniqueID,
        message: "Emit to server",
      };
      SaveLog(log_data);
      //-------------------------------------------

      this_.sendDataToSocket(message);
    }, 1500);
  }

  hybridSessionStart = (dispatch, roomorIpAddress, isIp, audioGhostId) => {
    dispatch(showApiLoader({ loading: "loading" }));
    let isIpNew = isIp;
    let hitApi;
    let noChangedRoomName = getBaseConfig("noChangedRoomName");
    let url = Constant.App.ServerUrl;
    if (noChangedRoomName == true) {
      hitApi = axios.get(url + "/start-audio-route?isIP=" + isIpNew +
        "&roomname=" +
        roomorIpAddress +
        "&server=" +
        getBaseConfig("serverVarInHybridsession") +
        "&processtype=routing" +
        `&visibleRoom=${CURRENT_ROOM_NAME}`
      );
    } else {
      hitApi = axios.get(url +
        "/start-audio-route?isIP=" +
        isIpNew +
        "&roomname=" +
        roomorIpAddress +
        "&server=" +
        getBaseConfig("serverVarInHybridsession") +
        "&processtype=routing"
      );
    }
    hitApi
      .then(async (response) => {
        if (response?.data?.status) {
          //CHECK HYBRID CHECKBOX
          dispatch(setHybridSession(true, "hybridSessionStart"));
          const { id } = this.props.localUser;
          const session_data = {
            status: true,
            location: CURRENT_ROOM_LOCATION,
            userId: id,
          };

          socketEmit("hybrid_session", session_data);

          this.setState({
            isHybridSessionActive: true,
          });

          //UPPDATE AUDIO GHOST VALUE

          //NOTE : If audio ghost connect only then set this store this process is automatic don't do it manually
          // const data = {
          //   audioGhostId: audioGhostId,
          //   isConnectedAudioGhost: false,
          // };
          // dispatch(connectAudioGhost(data));

          if (this.state.isHybridSessionActive == true) {
            hybridClickedYes = false;
            //DISABLE HYBRID BUTTON
            this.disableHybridButton()
          }

          dispatch(
            hideApiLoader({
              loading: false,
            })
          );


          // check if the hybrid mode is not disable after specific time
          if (getBaseConfig("autoDisableHybrid") == true) {
            let checkStatusTimer = 40000;
            let this_ = this;
            setTimeout(async function () {
              let store_v1 = getStore(FEATURE_CUSTOM_REDUX);
              let ghostConnected = store_v1.isConnectedAudioGhost;
              let ghostId = store_v1.audioGhostId;
              console.log("I will check hybrid status as i request to close it => ghost id ", ghostId);

              if (ghostConnected && ghostId) {
                const hybridStatus = await getHybridSessionStatus(roomorIpAddress);
                console.log("hybridStatus =>", hybridStatus)
                if (hybridStatus.status == 1) {
                  if (!hybridStatus.processStatus) {
                    const { id } = this_.props.localUser;
                    const session_data = {
                      status: false,
                      location: CURRENT_ROOM_LOCATION,
                      userId: id,
                      removeElementId: ghostId
                    };
                    socketEmit("hybrid_session", session_data);

                    try {
                      var elements = document.querySelectorAll('audio[id^="remoteAudio_' + ghostId + '"]');
                      console.log("ghost ids list =>", elements)
                      if (elements.length > 0) {
                        setTimeout(function () {
                          dispatch(setVolume(ghostId, 0))
                          elements[0].muted = true;
                          elements[0].setAttribute("muted", true);
                          kickoutHybridUser(ghostId)
                        }, 4000)
                      }
                    } catch (e) {
                      console.log("hybrid id error =>", e)
                    }

                    dispatch(connectAudioGhost({
                      audioGhostId: null,
                      isConnectedAudioGhost: false
                    }));
                  }
                }
              }
            }, checkStatusTimer)
          }

          //BIND NOTIFICATION
          dispatch(
            showNotification(
              {
                titleKey: ct("Translate.messages.hybridSystemConnectionTitle"),
                descriptionKey: ct("Translate.messages.hybridSystemConnection"),
                customActionNameKey: ["hybrid.init"],
                uid: "hybrid.init",
              },
              NOTIFICATION_TIMEOUT_TYPE.STICKY
            )
          );
          sendAnalytics({
            action: "hybrid-session",
            source: "settings",
            category: "settings hybrid",
          });
        } else if (!response?.data?.status && response?.data?.type == 1) {
          dispatch(
            hideApiLoader({
              loading: false,
            })
          );

          //BIND NOTIFICATION
          dispatch(
            showErrorNotification({
              titleKey: ct("Translate.messages.busyServer"),
              descriptionKey: await dynamicMessageLocale(response.data.message),
            })
          );
          dispatch(setHybridSession(false, "busyServer 1"))
          this.setState({
            isHybridSessionActive: false,
          });
        } else {
          this.setState({
            isHybridSessionActive: true,
          });
          this.disableHybridButton()
          dispatch(showErrorNotification({
            titleKey: ct("Translate.messages.busyServer"),
            descriptionKey: await dynamicMessageLocale(response.data.message),
          }))
          dispatch(setHybridSession(false, "busyServer 2"))
          this.setState({
            isHybridSessionActive: false,
          });
          dispatch(
            hideApiLoader({
              loading: false,
            })
          );
        }
      })
      .catch((error) => {
        console.log("Voice sync API error =>", error);
      });
  };

  disableHybridButton = () => {
    let hasButton = document.getElementById("hybrid-btn");
    if (hasButton) {
      hasButton.disabled = true;
      setTimeout(() => {
        document.getElementById("hybrid-btn").disabled = false;
      }, 15000);
    }
  }
  //  Jitsi to jamulus
  handleHybridSession = (WillEnable) => {
    const {
      roomorIpAddress,
      audioGhostId,
      dispatch,
      isRecording,
      isStreaming,
      localUser
    } = this.props;
    let isIp = _ValidateIPaddress(roomorIpAddress);
    //TO HANDLE DISABLE_ENABLE BUTTON
    hybridClickedYes = true;

    // if (isRecording && isRecording > 0) {
    //   alert(Translate.messages.recordingToPauseForHybrid);
    //   return false;
    // } else if (isStreaming && isStreaming > 0) {
    //   alert(Translate.messages.streamingToPauseForHybrid);
    //   return false;
    // }

    if (WillEnable) {
      this.hybridSessionStart(dispatch, roomorIpAddress, isIp, audioGhostId);
    } else {
      // to stop the process
      dispatch(showApiLoader({ loading: "loading" }));
      axios
        .get(
          Constant.App.ServerUrl +
          "/stop-audio-route?roomname=" +
          roomorIpAddress +
          "&processtype=routing"
        )
        .then((response) => {
          if (response.data.status) {
            dispatch(setHybridSession(false, "handleHybridSession"));

            const { id } = this.props.localUser;
            const session_data = {
              status: false,
              location: CURRENT_ROOM_LOCATION,
              userId: id,
            };

            socketEmit("hybrid_session", session_data);

            this.setState({
              isHybridSessionActive: false,
            });

            //DISABLE HYBRID BUTTON
            this.disableHybridButton()

            dispatch(
              hideApiLoader({
                loading: false,
              })
            );

            // check if the hybrid mode is not disable after specific time
            if (getBaseConfig("autoDisableHybrid") == true) {
              let checkStatusTimer = 40000;
              let this_ = this;
              setTimeout(async function () {

                let store_v1 = getStore(FEATURE_CUSTOM_REDUX);
                let ghostConnected = store_v1.isConnectedAudioGhost;
                let ghostId = store_v1.audioGhostId;
                console.log("I will check hybrid status as i request to close it => ghost id ", ghostId);

                if (ghostConnected && ghostId) {
                  const hybridStatus = await getHybridSessionStatus(roomorIpAddress);
                  console.log("hybridStatus =>", hybridStatus)
                  if (hybridStatus.status == 1) {
                    if (!hybridStatus.processStatus) {
                      const { id } = this_.props.localUser;
                      const session_data = {
                        status: false,
                        location: CURRENT_ROOM_LOCATION,
                        userId: id,
                        removeElementId: ghostId
                      };
                      socketEmit("hybrid_session", session_data);

                      try {
                        var elements = document.querySelectorAll('audio[id^="remoteAudio_' + ghostId + '"]');
                        console.log("ghost ids list =>", elements)
                        if (elements.length > 0) {
                          setTimeout(function () {
                            dispatch(setVolume(ghostId, 0))
                            elements[0].muted = true;
                            elements[0].setAttribute("muted", true);
                            kickoutHybridUser(ghostId)
                          }, 4000)
                        }
                      } catch (e) {
                        console.log("hybrid id error =>", e)
                      }

                      dispatch(connectAudioGhost({
                        audioGhostId: null,
                        isConnectedAudioGhost: false
                      }));
                    }
                  }
                }
              }, checkStatusTimer)
            }


            //BIND NOTIFICATION
            dispatch(
              showNotification(
                {
                  titleKey: ct("Translate.messages.disconnecting"),
                  descriptionKey: ct("Translate.messages.disconnectingHybrid"),
                  customActionNameKey: ["hybrid.stop"],
                  uid: "hybrid.stop",
                },
                NOTIFICATION_TIMEOUT_TYPE.STICKY
              )
            );
          } else {
            dispatch(
              hideApiLoader({
                loading: false,
              })
            );
          }
          sendAnalytics({
            action: "hybrid-session",
            source: "settings",
            category: "settings hybrid",
          });
        })
        .catch((error) => {
          console.log("Voice sync API error =>", error);
        });
    }
  };

  // audio channel change modal
  monoAudioChannelModal() {
    return (
      <ModalTransition>
        <Modal
          onClose={() =>
            this.closeAudioChannel({
              mono: false,
            })
          }
          testId={"volume-pan-mono"}
        >
          <ModalHeader className="vol-pan-container">
            <ModalTitle>{ct("rta-trmc.mixer.enableMonoAudio")}</ModalTitle>
            <button
              id="enable-mono-audio-cross-btn"
              type="button"
              style={{ color: "#fff" }}
              className="c-button c-button--close"
              onClick={() =>
                this.closeAudioChannel({
                  mono: false,
                })
              }
            >
              ×
            </button>
          </ModalHeader>
          <ModalBody>
            <p
              style={{
                padding: "10px 0",
                color: "#000",
              }}
            >
              {ct("Translate.messages.monoChannel")}
            </p>
          </ModalBody>
          <ModalFooter className="justify-content-between text-right">
            <Button
              id="enable-mono-audio-submit-btn"
              appearance="primary"
              className="submit-button login-btn-pass join-meeting-pass"
              onClick={() => {
                this.changeAudioChannel(
                  {
                    target: {
                      name: "channel",
                      value: this.state.prevVolState.mode,
                    },
                  },
                  0
                ),
                  this.closeAudioChannel({
                    mono: false,
                  });
              }}
            >
              {ct("Translate.buttonTitle.okSmall")}
            </Button>
            <Button
              id="enable-mono-audio-cancel-btn"
              appearance="subtle"
              onClick={() =>
                this.closeAudioChannel({
                  mono: false,
                })
              }
            >
              {ct("Translate.buttonTitle.cancelSmall")}
            </Button>
          </ModalFooter>
        </Modal>
      </ModalTransition>
    );
  }

  // ping/overall value check if it is above 500 ms
  valueCheck(value) {
    let showValue = value.split("ms");
    showValue = Number(showValue[0]);
    if (showValue >= 500) {
      showValue = ct("rta-trmc.mixer.cannotDetect");
    } else {
      showValue = value;
    }
    return showValue;
  }

  async publicIpcheck() {
    let publicIp = await getPublicIp();
    if (getBaseConfig("jitterBufferIP").includes(publicIp) || getBaseConfig("jitterBufferIP").includes("showToAll")) {
      this.setState({
        showJitterIP: true,
      });
    }
  }

  closeTab = () => {
    this.props.onClose();
    dispatch(setOutAutoManage(this.state.isAutoManageHostClicked));
  };

  handleIsThirdparty = (item) => {
    let thirdPartyCurrentHost = false;
    let mixerIP;
    if (item.thirdParty) {
      let roomUrl = CURRENT_ROOM_NAME;
      let noChangedRoomName =
        getBaseConfig(
          "noChangedRoomName"
        );
      if (noChangedRoomName == true) {
        const { roomorIpAddress } =
          this.props;
        roomUrl = roomorIpAddress;
        if (
          roomUrl &&
          roomUrl.includes(":")
        ) {
          roomUrl = roomUrl.split(":");
          roomUrl = roomUrl[0];
        }
      } else {
        if (roomUrl.includes("_")) {
          roomUrl = roomUrl.split("_");
          roomUrl = roomUrl[0];
        }
      }
      if (item.thirdParty == roomUrl) {
        thirdPartyCurrentHost = true;
      }
    }
    if (item.ipAddress) {
      if (item.ipAddress.includes(":")) {
        mixerIP = item.ipAddress.replace(
          ":",
          "_"
        );
      }
    }
    return { thirdPartyCurrentHost, mixerIP }
  }

  hostCheckboxDisabled = () => {
    Toast(ct("Translate.messages.autoHostCheckboxDisabled"), Constant.App.ToastTime.LongCloseTime);
  }

  handleInstrumentList = (e) => {
    try {
      const isSpace = e?.split(" ")?.length > 1;
      let key = e;
      if (isSpace) {
        key = e.replace(" ", "_");
      }
      return ct(`rta-trmc.mixer.instrumentList.${key?.toLowerCase()}`);
    } catch (error) {
      return e;
    }
  }
  handleExistingEnbleHybrid = () => {
    toast(ct("rta-trmc.mixer.alreadyEnableHybrid"))

    let hybridButton = document.querySelector(".helt-enable-hybrid")
    if (hybridButton) {
      hybridButton.checked = false;
    }
  }

  render() {
    const { usersData, latencyData, onClose } = this.props;

    const {
      users,
      currentSetting,
      defaultSetting,
      prefSetting,
      safeSetting,
      safeSettingValue,
      prefSettingValue,
      defaultSettingValue,
      currentSettingValue,
      roomorIpAddress,
    } = usersData;

    const {
      firstname,
      instrumentName,
      device,
      audioChannel,
      audioQuality,
      sliderLeftValue,
      sliderRightValue,
      isJitBuf,
      isSmallNetworkEnable,
      showJitterBuffer,
      showdrop,
      //hostTabData,
      sliderPanValue,
      sliderReverbValue,
      leftReverb,
      rightReverb,
      tabSelected,
      isAutoManageHostClicked,
      initialWait,
      showJitterIP,
      showHostRefresh,
    } = this.state;

    let {
      hostTabData,
      hostRefresh,
      hostRefreshTimer,
      isHostInitWaiting,
      hostButtonAction,
      //localUserName,
      mixerDisplayName,
      audioGhostId,
      isConnectedAudioGhost,
      currentSoundCard,
      soundCards
    } = this.props;

    let info1 = ct("rta-trmc.mixer.infoMsg1");
    let info2 = ct("rta-trmc.mixer.infoMsg2");
    let info3 = ct("rta-trmc.mixer.infoMsg3");
    let info4 = ct("rta-trmc.mixer.infoMsg4");
    let info5 = ct("rta-trmc.mixer.infoMsg5");

    const isMobile = isMobileBrowserC();
    let manageHostServerName = getBaseConfig("manageHostServerName")

    return (
      <div className="modalSound">
        {this.state.prevVolState.mono && this.monoAudioChannelModal()}
        <div className="modal modal-content">
          <div className="modal-content mixerSettingWrapper">
            {getBaseConfig("tools").includes("manageHostTab") &&
              this.state.showNewRoomModal ? (
              ""
            ) : (
              <>
                {!showHostRefresh ? (
                  ""
                ) : (
                  <span className="make-host-refresh">
                    {/* {
                        hostRefreshTimer ?
                          <img
                            src={refresh}
                            className={"refresh-host disable "}
                          />
                          : <img
                            src={refresh}
                            className={"refresh-host "}
                          // onClick={() => this.handleHostRefresh()}
                          />
                      } */}
                  </span>
                )}
              </>
            )}
            <span
              id="close-setting-modal"
              className="close"
              onClick={() => this.closeTab()}
            >
              <img src={cross} data-set={tabSelected} />
            </span>
            <Tabs
              // defaultIndex={tabSelected}
              selectedIndex={tabSelected}
              onSelect={(index) => this.setState({ tabSelected: index })}
            >
              <TabList className={isMobile && this.state.orientationView == "portrait-primary" ? 'react-tabs__tab-list mixer-mobile-tabs' : 'react-tabs__tab-list'}>
                <Tab
                  className={isMobile && this.state.orientationView == "portrait-primary" ? "react-tabs__tab mobile-react-tabs" : "react-tabs__tab"}
                  data-id="profile-settings-tab"
                  onClick={() => this.closeHostTab()}
                >
                  {
                    isMobile && this.state.orientationView == "portrait-primary" ? <i className="fa fa-user" aria-hidden="true"></i> : ct("rta-trmc.mixer.profileSettingTab")
                  }
                </Tab>
                <Tab
                  className={isMobile && this.state.orientationView == "portrait-primary" ? "react-tabs__tab mobile-react-tabs" : "react-tabs__tab"}
                  data-id="audio-settings-tab"
                  onClick={() => this.closeHostTab()}
                >
                  {
                    isMobile && this.state.orientationView == "portrait-primary" ? <i style={{ transform: "rotate(90deg)" }} className="fa fa-sliders audio-settings-icon" aria-hidden="true"></i> : ct("rta-trmc.mixer.audioSettingsTab")
                  }
                </Tab>
                <Tab
                  className={isMobile && this.state.orientationView == "portrait-primary" ? "react-tabs__tab mobile-react-tabs" : "react-tabs__tab"}
                  data-id="latency-metrics-tab"
                  onClick={() => this.startLatency()}
                >
                  {
                    isMobile && this.state.orientationView == "portrait-primary" ? <i className="fa fa-line-chart" aria-hidden="true"></i> : ct("rta-trmc.mixer.latencyMetricsTab")
                  }
                </Tab>
                {/* {usersData.isHost ? */}
                {/* <Tab onClick={() => this.startHostTab()}>Host</Tab> */}
                {/* <Tab onClick={() => this.closeHostTab()}>Host</Tab> */}
                {getBaseConfig("tools").includes("manageHostTab") && (
                  <Tab
                    className={isMobile && this.state.orientationView == "portrait-primary" ? "react-tabs__tab mobile-react-tabs" : "react-tabs__tab"}
                    data-id="host-tab"
                    onClick={() => this.closeHostTabExtra()}
                  >
                    {
                      isMobile && this.state.orientationView == "portrait-primary" ? <i className="fa fa-desktop" aria-hidden="true"></i> : ct("rta-trmc.mixer.hostTab")
                    }
                  </Tab>
                )}
                {/* : null} */}
              </TabList>

              <TabPanel>
                <div className="wrap profilesettingsWrap">
                  <div className="fleft">
                    <span className="lbl-left">
                      <div style={{ position: 'relative' }} className="noteWrapper"><label htmlFor="firstname">{ct("rta-trmc.mixer.yourProfileName")}</label>
                        <MixerTooltip className="custom-tooltip-mixer" position="top" content={ct("Translate.tooltipContent.enterName")}>
                          <span className="tooltip-padding">
                            <i
                              className="fa fa-info-circle"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </MixerTooltip>
                      </div>
                    </span>
                    <span className="flef-dropdown">
                      {getBaseConfig("profileNameEdit") == false ? (
                        <input
                          className="form-control-fname r form-control"
                          id="firstname"
                          name="firstname"
                          type="text"
                          value={firstname || ""}
                          onChange={this.updateProfile}
                          autoComplete="off"
                          disabled={true}
                        // maxLength={USER_NAME_LEN}
                        />
                      ) : (
                        <input
                          className="form-control-fname r form-control"
                          id="firstname"
                          name="firstname"
                          type="text"
                          value={mixerDisplayName || firstname}
                          // maxLength={USER_NAME_LEN}
                          onChange={this.updateProfile}
                          autoComplete="off"
                        />
                      )}
                    </span>
                  </div>
                  <div className="fright">
                    <span className="lbl-right">
                      <div style={{ position: 'relative' }} className="noteWrapper">
                        <label htmlFor="instrument">{ct("rta-trmc.mixer.yourInstrument")}</label>
                        <MixerTooltip showOnTab={true} className="custom-tooltip-mixer" position="bottom" content={ct("Translate.tooltipContent.selectInstrument")}>
                          <span className="tooltip-padding">
                            <i
                              className="fa fa-info-circle"
                              aria-hidden="true"
                            ></i>
                          </span></MixerTooltip></div>
                    </span>
                    <span>
                      <select
                        id="instrument"
                        name="instrument"
                        value={instrumentName}
                        onChange={this.updateInstrument}
                        className="form-control instrument instrumentField"
                      >
                        {instrumentArray.map((option) => (
                          <option key={option} value={option}>
                            {this.handleInstrumentList(option)}
                          </option>
                        ))}
                      </select>
                      <br />
                    </span>
                  </div>
                </div>
              </TabPanel>

              <TabPanel>
                <div className="container Setting tab-height">
                  <div className="row">
                    <div className="col-md-5 col1 col-sm-12">
                      <h2 className="head-text">{ct("rta-trmc.mixer.audioSettings")}</h2>
                      <div className="setting-1">
                        <div className="label-wrapper" >
                          <label className="device">
                            <>{ct("rta-trmc.mixer.audioChannels")}</>
                            <MixerTooltip showOnTab={true} className="custom-tooltip-mixer custom-tooltip-text custom-tooltip-margin" position="bottom" content={ct("Translate.tooltipContent.audioChannel")}>
                              <span className="tooltip-padding">
                                <i
                                  className="fa fa-info-circle"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </MixerTooltip>
                          </label>
                        </div>
                        <div className="dropdown1">
                          <select
                            id="channel"
                            name="channel"
                            value={audioChannel}
                            // onChange={this.changeAudioChannel} className="form-control channel">
                            onChange={(e) => this.changeAudioChannel(e, 1)}
                            className="form-control channel"
                          >
                            {channelsArray.map((option) => (
                              <option key={option} value={option.value}>
                                {ct(option.locale)}
                              </option>
                            ))}
                          </select>
                          <br />
                        </div>
                      </div>
                      <div className="setting-2">
                        <div className="label-wrapper">
                          <label className="device">
                            <>{ct("rta-trmc.mixer.audioQuality")}</>
                            <MixerTooltip className="custom-tooltip-mixer custom-tooltip-text custom-tooltip-margin" position="bottom" content={ct("Translate.tooltipContent.audioQuality")}>
                              <span className="tooltip-padding">
                                <i
                                  className="fa fa-info-circle"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </MixerTooltip>
                          </label>
                        </div>
                        <div className="dropdown2">
                          <select
                            id="quality"
                            name="quality"
                            value={audioQuality}
                            onChange={this.changeAudioQuality}
                            className="form-control quality"
                          >
                            {qualityArray.map((option) => (
                              <option key={option} value={option.value}>
                                {ct(option.locale)}
                              </option>
                            ))}
                          </select>
                          <br />
                        </div>
                      </div>

                      {getBaseConfig("showSoftwareVersion") &&
                        <div className="setting-4">
                          <div className="label-wrapper">
                            <label className="device">
                              <>{ct("rta-trmc.mixer.audioInterface")}</>
                              <MixerTooltip className="custom-tooltip-mixer custom-tooltip-text custom-tooltip-margin" position="bottom" content={ct("Translate.tooltipContent.audioInterface")}>
                                <span className="tooltip-padding">
                                  <i
                                    className="fa fa-info-circle"
                                    aria-hidden="true"
                                  ></i>
                                </span>
                              </MixerTooltip>
                            </label>
                          </div>
                          <div className="dropdown3">
                            <select
                              id="interface"
                              name="interface"
                              onChange={this.changeAudioInterface}
                              className="form-control interface"
                              value={soundCards.indexOf(currentSoundCard)}
                            >
                              {soundCards.map((option, index) => (
                                <option key={index} value={index}>
                                  {ct(option)}
                                </option>
                              ))}
                            </select>
                            <br />
                          </div>
                        </div>
                      }

                      {getBaseConfig("tools").includes("hybridMode") && (
                        <div className="setting-3">
                          <div className="label-wrapper">

                            <label className="hybrid-session-label checkwrapper ">
                              <>{ct("rta-trmc.mixer.hybridSession")}</>
                              <MixerTooltip className="custom-tooltip-mixer custom-tooltip-text custom-tooltip-margin" position="bottom" content={ct("Translate.tooltipContent.hybridSession")}>
                                <span className="tooltip-padding">
                                  <i
                                    className="fa fa-info-circle"
                                    aria-hidden="true"
                                  ></i>
                                </span>
                              </MixerTooltip>
                            </label>
                          </div>
                          <div className="check-btn">

                            {(audioGhostId && isConnectedAudioGhost && !this.state.isHybridSessionActive)
                              ? <>
                                <input
                                  type="checkbox"
                                  id="hybrid-btn-disable"
                                  className="helt-enable-hybrid"
                                  checked={false}
                                  onChange={() => {
                                    this.handleExistingEnbleHybrid()
                                  }}
                                />
                                <span className="checkmark"></span>
                              </> :
                              <>
                                <input
                                  type="checkbox"
                                  id="hybrid-btn"
                                  checked={this.state.isHybridSessionActive}
                                  value={this.state.isHybridSessionActive}
                                  onChange={() => {
                                    this.handleHybridSession(
                                      !this.state.isHybridSessionActive
                                    );
                                  }}
                                />
                                <span className="checkmark"></span>
                              </>
                            }
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="col-md-7 col2 col-sm-12">
                      {
                        CURRENT_ROOM_NAME == "dev-testing-room" ?
                          <>
                            <button
                              onClick={() => {
                                dispatch(setVolume(this.props.audioGhostId, 0));
                              }}
                            >Enable</button>

                            <button
                              onClick={() => {
                                dispatch(setVolume(this.props.audioGhostId, 1));
                              }}
                            >Disable</button></> : ""
                      }
                      <div className="row">
                        <div className="col-4 buffer-left">
                          {showJitterIP && (
                            <div>
                              <h2 className="head-text ml-0 text-left">
                                {ct("rta-trmc.mixer.jitterBuffer")}
                              </h2>
                              <div className="position-relative">
                                <label className="check-one">
                                  {ct("rta-trmc.mixer.auto")}
                                  <input
                                    className="lbl-ryt"
                                    type="checkbox"
                                    value={isJitBuf}
                                    checked={this.state.isJitBuf}
                                    onChange={({ target: { name, value } }) => {
                                      this.setState({
                                        isJitBuf: !this.state.isJitBuf,
                                      });
                                      this._handleJitBufferMethod(
                                        this.state.isJitBuf
                                      );
                                    }}
                                  />
                                  <span className="checkmark"></span>
                                </label>
                                <div className="mainls">
                                  <label className="lbl-local">{ct("rta-trmc.mixer.local")} </label>
                                  <label className="lbl-server"> {ct("rta-trmc.mixer.server")}</label>
                                </div>
                                <div>
                                  <label className="slider-val1">
                                    {usersData.sliderLeft}
                                  </label>
                                  <label className="slider-val2">
                                    {usersData.sliderRight}
                                  </label>
                                </div>
                                <div className="sec-img">
                                  <Slider
                                    active="false"
                                    disabled={true}
                                    name="local"
                                    min={0}
                                    max={20}
                                    value={sliderLeftValue}
                                    className="left-slide-bar"
                                    orientation="vertical"
                                    onChange={(value) => {
                                      if (!isJitBuf) {
                                        this.changeSliderLeft(value);
                                      }
                                    }}
                                  />

                                  <Slider
                                    name="server"
                                    min={0}
                                    max={20}
                                    value={sliderRightValue}
                                    className="right-slide-bar"
                                    orientation="vertical"
                                    onChange={(value) => {
                                      if (!isJitBuf) {
                                        this.changeSliderRight(value);
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="col-8 buffer-right">
                          <h2 className="head-text ml-0 text-left">
                            {ct("rta-trmc.mixer.audioMode")}
                          </h2>

                          {/* <div className="radio d-flex align-items-start" value={prefSettingValue} onClick={() => this.showAlert(prefSettingValue)} > */}
                          <div
                            className="radio align-items-start custom-radio d-flex"
                            // value={prefSettingValue}
                            // onClick={() => this.showAlert(prefSettingValue)}
                            id={'first-radio-btn'}
                          >
                            {/* <img src={this.state.firstBufferDelay ? radioActive : radioInactive} /> */}
                            <div value={prefSettingValue}
                              onClick={() => this.showAlert(prefSettingValue)} style={{ marginRight: "10px" }}>
                              <Radio active={this.state.firstBufferDelay} />
                            </div>
                            <div style={{ position: 'relative' }} >
                              <label className={isMobile ? `` : ''}>
                                <>{ct("rta-trmc.mixer.audioQuality64")}</>
                                <MixerTooltip style={{ alignSelf: 'center' }} className="custom-tooltip-mixer" position="bottom" content={ct("Translate.tooltipContent.lowestLatencyMode")}>
                                  <span className="tooltip-padding">
                                    <i
                                      className="fa fa-info-circle"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                </MixerTooltip>
                              </label>
                            </div>
                            {/* <label> {prefSetting} </label> */}
                          </div>

                          {/* <div className="radio d-flex align-items-start" value={defaultSettingValue} onClick={() => this.showAlert(defaultSettingValue)}> */}
                          <div
                            className="radio align-items-start custom-radio d-flex"
                            // value={defaultSettingValue}
                            // onClick={() => this.showAlert(defaultSettingValue)}
                            id={'second-radio-btn'}
                          >
                            {/* <img src={this.state.secondBufferDelay ? radioActive : radioInactive} /> */}

                            <div value={defaultSettingValue}
                              onClick={() => this.showAlert(defaultSettingValue)} style={{ marginRight: "10px" }}>
                              <Radio active={this.state.secondBufferDelay} />
                            </div>
                            <div style={{ position: 'relative' }} >
                              <label className={isMobile ? `` : ''}>
                                <>{ct("rta-trmc.mixer.audioQuality128")}</>
                                <MixerTooltip style={{ alignSelf: 'center' }} className="custom-tooltip-mixer" position="bottom" content={ct("Translate.tooltipContent.highestLatencyMode")}>
                                  <span className="tooltip-padding">
                                    <i
                                      className="fa fa-info-circle"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                </MixerTooltip>
                              </label>
                            </div>
                            {/* <label>{defaultSetting}</label> */}
                          </div>

                          {/* <div className="radio" value={safeSettingValue} onClick={() => this.showAlert(safeSettingValue)} >
                            <img src={this.state.thirdBufferDelay ? radioActive : radioInactive} />
                            <label> {safeSetting} </label>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>

              <TabPanel>
                <div className="latency-setting">
                  <div className="d-flex w-100 scrollbottom">
                    <div className="late-left">
                      <div className="row no-gutters mb-2 flex-nowrap">
                        <label
                          htmlFor="delay"
                          className="l-pill mr-2"
                          style={{ backgroundColor: "#3366cc" }}
                        >
                          {ct("rta-trmc.mixer.overallDelay")}:
                        </label>
                        {latencyData ? this.valueCheck(latencyData.delay) : ""}
                        <MixerTooltip content={ct("Translate.tooltipContent.latencyMetrics")} >
                          <span onClick={() =>
                            this.setState({ showInfo: true, info: info1 })
                          } className="tooltip-padding">
                            <i
                              className="fa fa-info-circle"
                              aria-hidden="true"
                            ></i>
                          </span>
                        </MixerTooltip>
                      </div>
                      <div className="row no-gutters mb-2 flex-nowrap">
                        <label
                          htmlFor="pingTime"
                          className="l-pill mr-2"
                          style={{ backgroundColor: "#dc3912" }}
                        >
                          {ct("rta-trmc.mixer.pingTime")}:
                        </label>
                        {latencyData
                          ? this.valueCheck(latencyData.pingTime)
                          : ""}
                        <MixerTooltip content={ct("Translate.tooltipContent.latencyMetrics")} >
                          <span onClick={() =>
                            this.setState({ showInfo: true, info: info2 })
                          } className="tooltip-padding">
                            <i
                              className="fa fa-info-circle"
                              aria-hidden="true"
                            ></i></span></MixerTooltip>
                      </div>
                      <div className="row no-gutters mb-2 flex-nowrap">
                        <label
                          htmlFor="pingTime"
                          className="l-pill mr-2"
                          style={{ backgroundColor: "#ff9900" }}
                        >
                          {ct("rta-trmc.mixer.processingDelay")}:
                        </label>
                        {latencyData ? latencyData.processingDelay : ""}
                        <MixerTooltip content={ct("Translate.tooltipContent.latencyMetrics")} >
                          <span onClick={() =>
                            this.setState({ showInfo: true, info: info3 })
                          } className="tooltip-padding">
                            <i
                              className="fa fa-info-circle pl-2"
                              aria-hidden="true"
                              onClick={() =>
                                this.setState({ showInfo: true, info: info3 })
                              }
                            ></i></span></MixerTooltip>
                      </div>
                      <div className="row no-gutters mb-2 flex-nowrap">
                        <label htmlFor="upstream" className="mr-2">
                          {ct("rta-trmc.mixer.audioStreamRate")}:
                        </label>
                        {latencyData ? latencyData.upstream : ""}
                        <MixerTooltip content={ct("Translate.tooltipContent.latencyMetrics")} >
                          <span onClick={() =>
                            this.setState({ showInfo: true, info: info4 })
                          } className="tooltip-padding">
                            <i
                              className="fa fa-info-circle"
                              aria-hidden="true"
                            ></i></span></MixerTooltip>
                      </div>
                      <div className="row no-gutters align-items-center mb-3 flex-nowrap">
                        <label htmlFor="upstream" className="mr-2 mb-0">
                          {ct("rta-trmc.mixer.localJitterBuffer")}:
                        </label>
                        {this.state.showJitterBuffer}
                        {this.state.dropCount}
                        <img
                          src={this.state.showJitterBuffer ? green : red}
                          className="ml-4"
                        />
                        <MixerTooltip content={ct("Translate.tooltipContent.latencyMetrics")} >
                          <span onClick={() =>
                            this.setState({ showInfo: true, info: info5 })
                          } className="tooltip-padding">
                            <i
                              className="fa fa-info-circle"
                              aria-hidden="true"
                            ></i></span></MixerTooltip>
                      </div>
                    </div>

                    <div className="w-100">
                      <Chart
                        height={"190px"}
                        width={"100%"}
                        chartType="LineChart"
                        loader={<div>{ct("rta-trmc.mixer.loadingChatView")}</div>}
                        data={this.state.chartdata}
                        options={{
                          legend: "none",
                          hAxis: {
                            title: ct("rta-trmc.mixer.time"),
                            viewWindow: { min: 0 },
                          },
                          vAxis: {
                            title: ct("rta-trmc.mixer.delay"),
                            viewWindow: { min: 0 },
                          },
                          series: {
                            1: { curveType: "function" },
                          },
                        }}
                        rootProps={{ "data-testid": "2" }}
                      />
                    </div>
                  </div>
                  <div className="selectedInfo"> {this.state.info} </div>
                </div>
              </TabPanel>
              {getBaseConfig("tools").includes("manageHostTab") && (
                <TabPanel>
                  {this.state.showNewRoomModal ? (
                    <div className="min-form ">
                      <input
                        type="text"
                        autoFocus={true}
                        placeholder="Create a new room name "
                        className="enter-room-input text-white trans mb-4 manage-host-field"
                        id="enter_room_field"
                        value={this.state.ipNewroom}
                        onChange={this.setNewRoom}
                        required={true}
                        autoComplete="off"
                      />
                      <div className="slide-container buttons buttonWrapper d-flex justify-content-center">
                        <button
                          className="st-btn alter mx-3"
                          onClick={(e) => {
                            e.preventDefault();
                            this.sendNewRoom(1);
                          }}
                          type="button"
                        >
                          {ct("Translate.buttonTitle.okCaps")}
                        </button>
                        <button
                          className="st-btn border-btn white mx-3"
                          onClick={() =>
                            this.setState({
                              showNewRoomModal: false,
                              ipNewroom: "",
                            })
                          }
                          type="button"
                        >
                          {ct("Translate.buttonTitle.cancelSmall")}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="host-setting p-4 text-white">
                      <div className="mb-1">
                        {ct("rta-trmc.mixer.lowLatencyJamMsg")}
                      </div>
                      {(isMobile || isIpad()) && <span className="note-area" style={{ alignSelf: 'center' }} ><b>{ct("rta-trmc.mixer.note")}:&nbsp;</b>{ct("Translate.messages.tapAndHold1")} <i
                        className="fa fa-info-circle pl-2 pr-2"
                        style={{ alignSelf: 'center' }}
                        aria-hidden="true"
                      ></i> {ct("Translate.messages.tapAndHold2")}
                      </span>}
                      <div className="mt-3">
                        {
                          hostTabData &&
                            hostTabData.hasOwnProperty("users") &&
                            hostTabData?.users &&
                            hostTabData?.users.length > 0 &&
                            !hostButtonAction ? (
                            <>
                              <div className="setting-3">

                                <label className="pr-2 d-flex">
                                  <>{ct("rta-trmc.mixer.autoManageHost")}:</>
                                  <MixerTooltip style={{ marginLeft: '4px', alignSelf: 'center' }} showOnTab={true} className="custom-tooltip-mixer" position="top" content={ct("Translate.tooltipContent.autoManageHost")}>
                                    <span className="tooltip-padding">
                                      <i
                                        className="fa fa-info-circle tooltip-icon"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </MixerTooltip></label>
                                <div className="check-btn">
                                  <input
                                    className="lbl-ryt"
                                    type="checkbox"
                                    id="make-host-input"
                                    value={isAutoManageHostClicked}
                                    checked={this.state.isAutoManageHostClicked}
                                    onChange={(e) => {
                                      this.setState({
                                        isAutoManageHostClicked:
                                          !this.state.isAutoManageHostClicked,
                                      });
                                      this._selectAutoMakeHost(e, "manualClick");
                                    }}
                                  />
                                  <span className="checkmark theme-checkbox"></span>
                                </div>
                              </div>
                            </>
                          ) : (
                            null
                            // <>
                            //   <div
                            //     className="setting-3"
                            //     style={{ float: "left" }}
                            //   >
                            //     <label className="pr-2 d-flex">
                            //       <>Auto Manage Host:</>
                            //       <MixerTooltip style={{ marginLeft: '4px', alignSelf: 'center' }} showOnTab={true} className="custom-tooltip-mixer" position="top" content={Translate.tooltipContent.autoManageHost}>
                            //         <span className="tooltip-padding">
                            //           <i
                            //             className="fa fa-info-circle tooltip-icon"
                            //             aria-hidden="true"
                            //           ></i>
                            //         </span>
                            //       </MixerTooltip>
                            //     </label>
                            //     <div className="check-btn">
                            //       <input
                            //         className="lbl-ryt"
                            //         type="checkbox"
                            //         id="make-host-input-disabled"
                            //         value={isAutoManageHostClicked}
                            //         checked={this.state.isAutoManageHostClicked}
                            //         onChange={(e) => {
                            //           e.preventDefault();
                            //           this.hostCheckboxDisabled()
                            //         }
                            //         }
                            //       />
                            //       <span className="checkmark theme-checkbox"></span>
                            //     </div>
                            //   </div>
                            // </>
                          )}
                        <div className="recomended-host">
                          <b>
                            <span
                              title={ct("Translate.messages.hostToolTip")}
                              style={{ cursor: "pointer" }}
                            >
                              *
                            </span>{" "}
                            {ct("rta-trmc.mixer.recommendHost")}
                          </b>
                        </div>
                        {isHostInitWaiting ? (
                          <>
                            <div
                              className="hostcontent"
                              style={{
                                marginTop: "20px",
                              }}
                            >
                              <p>{ct("Translate.messages.hostDataWaiting")}</p>
                            </div>
                          </>
                        ) : !hostRefresh ? (
                          <>
                            {isMobile && this.state.orientationView == "portrait-primary" ? (
                              <>
                                {(hostTabData?.users || []).map((item, index) => {

                                  let { thirdPartyCurrentHost, mixerIP } = this.handleIsThirdparty(item);

                                  return (
                                    <HostCard
                                      makeHost={this.makeHost}
                                      item={item}
                                      index={index}
                                      hostButtonAction={hostButtonAction}
                                      valueCheck={this.valueCheck}
                                      thirdPartyCurrentHost={thirdPartyCurrentHost}
                                    />
                                  );
                                })}
                              </>
                            ) : (
                              <div className="host-table">
                                <table id="host-table" className="table table-bordered mb-0">
                                  <thead>
                                    <tr>
                                      <th>{ct("rta-trmc.mixer.userName")}</th>
                                      <th>{ct("rta-trmc.mixer.avgPing")}</th>
                                      <th>{ct("rta-trmc.mixer.upSpeed")}</th>
                                      <th>{ct("rta-trmc.mixer.role")}</th>
                                      <th>{ct("rta-trmc.mixer.action")}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {hostTabData &&
                                      hostTabData.hasOwnProperty("users") &&
                                      hostTabData?.users &&
                                      hostTabData?.users.length > 0
                                      ? hostTabData.users.map((item, idx) => {
                                        let { thirdPartyCurrentHost, mixerIP } = this.handleIsThirdparty(item);
                                        let cityName = item.city
                                        if (cityName) {
                                          cityName = cityName.charAt(0).toUpperCase() + cityName.slice(1);
                                        }

                                        return (
                                          <tr
                                            key={idx}
                                            style={{
                                              fontWeight: item?.isRecommended
                                                ? "bold"
                                                : "normal",
                                              background: item?.isRecommended
                                                ? "var(--theme-mixer-tab-bgcolor-recommended)"
                                                : "var(--theme-mixer-tab-bgcolor)",
                                            }}
                                          >
                                            {item.isRecommended ? (
                                              <td>
                                                {item.name == "Mixer"
                                                  ?
                                                  // Only city name
                                                  // mixerIP + " - [" + item.city + "]"
                                                  cityName + " - [" + manageHostServerName + ct("rta-trmc.mixer.server") + "]"
                                                  :
                                                  item.name
                                                    ?
                                                    item.name
                                                    :
                                                    // Only city name
                                                    // item.thirdParty + " - [" + item.city + "]"
                                                    cityName + " - [" + manageHostServerName + ct("rta-trmc.mixer.server") + "]"
                                                }
                                                <span
                                                  title={
                                                    ct("Translate.messages.hostToolTip")
                                                  }
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  *
                                                </span>
                                              </td>
                                            ) : (
                                              <td>
                                                {item.name == "Mixer"
                                                  ?
                                                  // Only city name
                                                  // mixerIP + " - [" + item.city  + "]"
                                                  cityName + " - [" + manageHostServerName + ct("rta-trmc.mixer.server") + "]"
                                                  : item.name
                                                    ? item.name
                                                    :
                                                    // Only city name
                                                    // item.thirdParty + " - [" + item.city  + "]"
                                                    cityName + " - [" + manageHostServerName + ct("rta-trmc.mixer.server") + "]"
                                                }
                                              </td>
                                            )}
                                            <td>
                                              <>
                                                {this.valueCheck(
                                                  item.sumPing
                                                )}
                                              </>
                                            </td>
                                            <td>{item.upSpeed}</td>
                                            <td>
                                              {item.isHost ? ct("rta-trmc.mixer.host") : ct("rta-trmc.mixer.user")}
                                            </td>
                                            {item.isHost ||
                                              thirdPartyCurrentHost ? (
                                              <td>
                                                <label
                                                  className="text-inherit f-16"
                                                  style={{
                                                    fontWeight:
                                                      item?.isRecommended
                                                        ? "bold"
                                                        : "normal",
                                                  }}
                                                >
                                                  {ct("rta-trmc.mixer.currentHost")}
                                                </label>
                                              </td>
                                            ) : (
                                              <td className="text-center">
                                                {item.sumPing == "NA" ? (
                                                  <span>-</span>
                                                ) : (
                                                  <>
                                                    {hostButtonAction || _ValidateIPaddress(CURRENT_ROOM_NAME) ? (
                                                      <>
                                                        <button
                                                          id={`make-host-disabled-${idx}`}
                                                          className="border-btn font-weight-bold disabled"
                                                        >
                                                          {ct("rta-trmc.mixer.makeHost")}
                                                        </button>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <button
                                                          id={`make-host-${idx}`}
                                                          className="border-btn font-weight-bold"
                                                          onClick={() =>
                                                            this.makeHost(
                                                              item
                                                            )
                                                          }
                                                        >
                                                          {ct("rta-trmc.mixer.makeHost")}
                                                        </button>
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                              </td>
                                            )}
                                          </tr>
                                        );
                                      })
                                      : null}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </>
                        ) : (
                          <div
                            className=""
                            style={{
                              marginTop: "20px",
                            }}
                          >
                            <p>{ct("Translate.messages.hostDataWaiting")}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </TabPanel>
              )}
            </Tabs>
          </div>
          {(isMobile || isIpad()) && tabSelected != 2 && tabSelected != 3 && <span style={{ alignSelf: 'center' }} className="tap-and-hold"><b>{ct("rta-trmc.mixer.note")}:&nbsp;</b>{ct("Translate.messages.tapAndHold1")} <i
            className="fa fa-info-circle pl-2 pr-2"
            style={{ alignSelf: 'center' }}
            aria-hidden="true"
          ></i> {ct("Translate.messages.tapAndHold2")}
          </span>}
        </div>
      </div>
    );
  }
}

function _mapStateToProps(state) {
  const mixerDisplayName = getDisplayName(state);
  return {
    mixerDisplayName,
    usersData: state[FEATURE_CUSTOM_REDUX].usersData,
    textMessage: state["trmc/customLoader/modal"].textMessage,
    latencyData: state[FEATURE_CUSTOM_REDUX].latencyData,
    roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
    hostTabData: state[FEATURE_CUSTOM_REDUX].hostTabData,
    hostReload: state[FEATURE_CUSTOM_REDUX].hostReload,
    room: state[FEATURE_CUSTOM_REDUX].room,
    hostRefresh: state[FEATURE_CUSTOM_REDUX].hostRefresh,
    hostRefreshTimer: state[FEATURE_CUSTOM_REDUX].hostRefreshTimer,
    uniqueId: state[FEATURE_CUSTOM_REDUX].uniqueId,
    isConnectedAudioGhost: state[FEATURE_CUSTOM_REDUX].isConnectedAudioGhost,
    localUserName: state["features/base/participants"].local?.name,
    localUser: state["features/base/participants"].local,
    audioGhostId: state[FEATURE_CUSTOM_REDUX].audioGhostId,
    isHybridSession: state[FEATURE_CUSTOM_REDUX].isHybridSession,
    isRecording: state["features/recording"]?.sessionDatas?.filter(
      (e) => e.mode == "file" && e.status == "on"
    )?.length,
    isStreaming: state["features/recording"]?.sessionDatas?.filter(
      (e) => e.mode == "stream" && e.status == "on"
    )?.length,
    clickedAutoMakeHost: state[FEATURE_CUSTOM_REDUX].clickedAutoMakeHost,
    delayPanning: state[FEATURE_CUSTOM_REDUX].delayPanning,
    isHostInitWaiting: state[FEATURE_CUSTOM_REDUX].isHostInitWaiting,
    audioChannelSt: state[FEATURE_CUSTOM_REDUX].audioChannelSt,
    audioChannelConfig: state[FEATURE_CUSTOM_REDUX_V2].audioChannelConfig,
    deviceUserName: state[FEATURE_CUSTOM_REDUX_V2].deviceUserName,
    isModerator: isLocalParticipantModerator(state),
    _isLiveStreamRunning: Boolean(
      getActiveSession(state, JitsiRecordingConstants.mode.STREAM)
    ),
    _isRecordingRunning: Boolean(
      getActiveSession(state, JitsiRecordingConstants.mode.FILE)
    ),
    hostButtonAction: state[FEATURE_CUSTOM_REDUX_V2].hostButtonAction,
    outAutoManage: state[FEATURE_CUSTOM_REDUX_V2].outAutoManage,
    autoManageHostTrigger: state[FEATURE_CUSTOM_REDUX_V3].autoManageHostTrigger,
    userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
    disableRecIcon: state[FEATURE_CUSTOM_REDUX_V2].disableRecIcon,
    liveStreamingStatus: state[FEATURE_CUSTOM_REDUX_V3].liveStreamingStatus,
    remoteParticipants: getRemoteParticipants(state), // CUSTOM
    currentSoundCard: state[FEATURE_CUSTOM_REDUX_V3].currentSoundCard,
    soundCards: state[FEATURE_CUSTOM_REDUX_V3].soundCards,
  };
}

export default translate(connect(_mapStateToProps)(Settings));

const HostCard = ({
  item,
  index,
  hostButtonAction,
  valueCheck,
  thirdPartyCurrentHost,
  makeHost
}) => {

  let cityName = item.city
  if (cityName) {
    cityName = cityName.charAt(0).toUpperCase() + cityName.slice(1);
  }
  return (
    <Card
      className="mb-5 custom-card-wrapper custom-host-card-wrapper"
      key={index}
      sx={{ backgroundColor: item?.isRecommended ? "#31abb1 !important" : "#3ec0c5 !important" }}
    >
      <CardHeader
        sx={{ paddingBottom: "0px", paddingRight: "10px", paddingLeft: "10px" }}
        title={
          <div className="d-flex">
            <span>
              <b>{item?.isThirdParty ? `${ct("rta-trmc.mixer.rtaServer")} :` : `${ct("rta-trmc.mixer.userName")} :`}</b>
            </span>
            <span
              style={{
                fontWeight: item?.isRecommended ? "bold" : "normal",
              }}
              className="ml-2"
            >
              {item.isRecommended ? (
                <>
                  {item.name == "Mixer"
                    // Only city name
                    // ? mixerIP + " - [" + item.city + "]"
                    ? cityName
                    : item.name
                      ? item.name
                      // Only city name
                      // : item.thirdParty + " - [" + item.city + "]"
                      : cityName
                  }
                  <span
                    title={ct("Translate.messages.hostToolTip")}
                    style={{ cursor: "pointer" }}
                  >
                    *
                  </span>
                </>
              ) : (
                <>
                  {item.name == "Mixer"
                    // Only city name
                    // ? mixerIP + " - [" + item.city + "]"
                    ? cityName
                    : item.name
                      ? item.name
                      // Only city name
                      // : item.thirdParty + " - [" + item.city + "]"
                      : cityName
                  }
                </>
              )}
            </span>
          </div>
        }
      />
      <CardContent sx={{ paddingTop: "0px", paddingBottom: "10px !important", paddingRight: "10px !important", paddingLeft: "10px !important" }}>
        <div className="d-flex">
          <Typography>
            <b>{ct("rta-trmc.mixer.avgPing")} :</b>
          </Typography>
          <Typography className="ml-2">{valueCheck(item.sumPing)}</Typography>
        </div>
        <div className="d-flex">
          <Typography>
            <b>{ct("rta-trmc.mixer.upSpeed")} :</b>
          </Typography>
          <Typography className="ml-2">{item.upSpeed}</Typography>
        </div>
        <div className="d-flex">
          <Typography>
            <b>{ct("rta-trmc.mixer.role")} :</b>
          </Typography>
          <Typography className="ml-2">
            {item.isHost ? "Host" : "User"}
          </Typography>
        </div>
        <div className="w-100 mt-2" style={{ textAlign: "-webkit-center" }}>
          {item.isHost || thirdPartyCurrentHost ? (
            <>
              <label
                className="text-inherit f-16"
                style={{
                  fontWeight: item?.isRecommended ? "bold" : "normal",
                  marginBottom: "0px"
                }}
              >
                {ct("rta-trmc.mixer.currentHost")}
              </label>
            </>
          ) : (
            <React.Fragment className="text-center">
              {item.sumPing == "NA" ? (
                <span>-</span>
              ) : (
                <>
                  {hostButtonAction || _ValidateIPaddress(CURRENT_ROOM_NAME) ? (
                    <>
                      <button
                        id={`make-host-disabled-${index}`}
                        className="border-btn font-weight-bold disabled"
                      >
                        {ct("rta-trmc.mixer.makeHost")}
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        id={`make-host-${index}`}
                        className="border-btn font-weight-bold"
                        onClick={() => makeHost(item)}
                      >
                        {ct("rta-trmc.mixer.makeHost")}
                      </button>
                    </>
                  )}
                </>
              )}
            </React.Fragment>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
